// GENERATED FILE — DO NOT EDIT.
//
// `supabase gen types typescript --linked --schema public`  (npm run gen:types)
//
// THIS IS THE OWNER'S COMPATIBILITY RULE EXPRESSED AS A COMPILER ERROR.
// His words: "of course the web app is gonna have more functions than the app, but make sure
// they are compatible… maybe few tweaks in the web app, maybe few in the app itself." BREADTH
// may differ; the MODEL may not. The model both surfaces share is this database — the phone
// reads it through PostgREST and so does this app — so generating the web app's types from the
// live schema makes "a web surface must not invent a concept the phone cannot express" a thing
// the compiler refuses rather than a thing a reviewer has to notice.
//
// Regenerate whenever a migration lands. If the web app then stops compiling, that is the rule
// working: a column it named no longer exists, or never did.
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  // Allows to automatically instantiate createClient with right options
  // instead of createClient<Database, { PostgrestVersion: 'XX' }>(URL, KEY)
  __InternalSupabase: {
    PostgrestVersion: "14.5"
  }
  public: {
    Tables: {
      app_admins: {
        Row: {
          user_id: string
        }
        Insert: {
          user_id: string
        }
        Update: {
          user_id?: string
        }
        Relationships: []
      }
      athlete_engine_state: {
        Row: {
          e1rm_kg: number | null
          engine_version: string | null
          fatigue: number | null
          key: string
          levers: Json | null
          scope: string
          set_target: number | null
          tested_max_seconds: number | null
          updated_at: string
          user_id: string
        }
        Insert: {
          e1rm_kg?: number | null
          engine_version?: string | null
          fatigue?: number | null
          key: string
          levers?: Json | null
          scope: string
          set_target?: number | null
          tested_max_seconds?: number | null
          updated_at?: string
          user_id: string
        }
        Update: {
          e1rm_kg?: number | null
          engine_version?: string | null
          fatigue?: number | null
          key?: string
          levers?: Json | null
          scope?: string
          set_target?: number | null
          tested_max_seconds?: number | null
          updated_at?: string
          user_id?: string
        }
        Relationships: []
      }
      beta_messages: {
        Row: {
          body: string
          created_at: string
          from_admin: boolean
          id: string
          read_at: string | null
          sender_id: string
          thread_user_id: string
        }
        Insert: {
          body: string
          created_at?: string
          from_admin?: boolean
          id?: string
          read_at?: string | null
          sender_id: string
          thread_user_id: string
        }
        Update: {
          body?: string
          created_at?: string
          from_admin?: boolean
          id?: string
          read_at?: string | null
          sender_id?: string
          thread_user_id?: string
        }
        Relationships: []
      }
      body_measurements: {
        Row: {
          appetite: number | null
          body_fat_percent: number | null
          chest_cm: number | null
          created_at: string
          hips_cm: number | null
          id: string
          left_calf_cm: number | null
          left_forearm_cm: number | null
          left_thigh_cm: number | null
          left_upper_arm_cm: number | null
          life_event: boolean | null
          life_event_note: string | null
          measured_at: string
          neck_cm: number | null
          notes: string | null
          photo_back_path: string | null
          photo_front_path: string | null
          photo_side_path: string | null
          right_calf_cm: number | null
          right_forearm_cm: number | null
          right_thigh_cm: number | null
          right_upper_arm_cm: number | null
          shoulders_cm: number | null
          sleep_hours: number | null
          training_desire: number | null
          updated_at: string
          user_id: string
          waist_cm: number | null
          water_tags: string[] | null
          weight_kg: number | null
        }
        Insert: {
          appetite?: number | null
          body_fat_percent?: number | null
          chest_cm?: number | null
          created_at?: string
          hips_cm?: number | null
          id?: string
          left_calf_cm?: number | null
          left_forearm_cm?: number | null
          left_thigh_cm?: number | null
          left_upper_arm_cm?: number | null
          life_event?: boolean | null
          life_event_note?: string | null
          measured_at?: string
          neck_cm?: number | null
          notes?: string | null
          photo_back_path?: string | null
          photo_front_path?: string | null
          photo_side_path?: string | null
          right_calf_cm?: number | null
          right_forearm_cm?: number | null
          right_thigh_cm?: number | null
          right_upper_arm_cm?: number | null
          shoulders_cm?: number | null
          sleep_hours?: number | null
          training_desire?: number | null
          updated_at?: string
          user_id: string
          waist_cm?: number | null
          water_tags?: string[] | null
          weight_kg?: number | null
        }
        Update: {
          appetite?: number | null
          body_fat_percent?: number | null
          chest_cm?: number | null
          created_at?: string
          hips_cm?: number | null
          id?: string
          left_calf_cm?: number | null
          left_forearm_cm?: number | null
          left_thigh_cm?: number | null
          left_upper_arm_cm?: number | null
          life_event?: boolean | null
          life_event_note?: string | null
          measured_at?: string
          neck_cm?: number | null
          notes?: string | null
          photo_back_path?: string | null
          photo_front_path?: string | null
          photo_side_path?: string | null
          right_calf_cm?: number | null
          right_forearm_cm?: number | null
          right_thigh_cm?: number | null
          right_upper_arm_cm?: number | null
          shoulders_cm?: number | null
          sleep_hours?: number | null
          training_desire?: number | null
          updated_at?: string
          user_id?: string
          waist_cm?: number | null
          water_tags?: string[] | null
          weight_kg?: number | null
        }
        Relationships: []
      }
      body_regions: {
        Row: {
          display_name: string
          id: string
        }
        Insert: {
          display_name: string
          id: string
        }
        Update: {
          display_name?: string
          id?: string
        }
        Relationships: []
      }
      client_exercise_notes: {
        Row: {
          body: string
          exercise_id: string
          source: string
          updated_at: string
          user_id: string
        }
        Insert: {
          body: string
          exercise_id: string
          source: string
          updated_at?: string
          user_id?: string
        }
        Update: {
          body?: string
          exercise_id?: string
          source?: string
          updated_at?: string
          user_id?: string
        }
        Relationships: []
      }
      client_reviewers: {
        Row: {
          accepted_at: string | null
          client_id: string
          ended_at: string | null
          ended_by: string | null
          id: string
          invited_at: string
          invited_email: string
          reviewer_id: string | null
          status: string
        }
        Insert: {
          accepted_at?: string | null
          client_id: string
          ended_at?: string | null
          ended_by?: string | null
          id?: string
          invited_at?: string
          invited_email: string
          reviewer_id?: string | null
          status?: string
        }
        Update: {
          accepted_at?: string | null
          client_id?: string
          ended_at?: string | null
          ended_by?: string | null
          id?: string
          invited_at?: string
          invited_email?: string
          reviewer_id?: string | null
          status?: string
        }
        Relationships: []
      }
      coach_assignments: {
        Row: {
          assigned_at: string
          client_id: string
          coach_id: string
          completed_at: string | null
          completed_minutes: number[]
          completed_snapshot: Json | null
          day_position: number
          hidden_from_client: boolean
          id: string
          is_deload: boolean
          note: string | null
          root_workout_id: string | null
          scheduled_date: string | null
          status: string
          workout_id: string
        }
        Insert: {
          assigned_at?: string
          client_id: string
          coach_id: string
          completed_at?: string | null
          completed_minutes?: number[]
          completed_snapshot?: Json | null
          day_position?: number
          hidden_from_client?: boolean
          id?: string
          is_deload?: boolean
          note?: string | null
          root_workout_id?: string | null
          scheduled_date?: string | null
          status?: string
          workout_id: string
        }
        Update: {
          assigned_at?: string
          client_id?: string
          coach_id?: string
          completed_at?: string | null
          completed_minutes?: number[]
          completed_snapshot?: Json | null
          day_position?: number
          hidden_from_client?: boolean
          id?: string
          is_deload?: boolean
          note?: string | null
          root_workout_id?: string | null
          scheduled_date?: string | null
          status?: string
          workout_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_assignments_root_workout_id_fkey"
            columns: ["root_workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_assignments_workout_id_fkey"
            columns: ["workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_call_rooms: {
        Row: {
          call_id: string
          closes_at: string
          coach_id: string
          opened_at: string
          room_name: string
          room_url: string | null
        }
        Insert: {
          call_id: string
          closes_at: string
          coach_id: string
          opened_at?: string
          room_name: string
          room_url?: string | null
        }
        Update: {
          call_id?: string
          closes_at?: string
          coach_id?: string
          opened_at?: string
          room_name?: string
          room_url?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "coach_call_rooms_call_id_fkey"
            columns: ["call_id"]
            isOneToOne: true
            referencedRelation: "coach_calls"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_calls: {
        Row: {
          cancelled_at: string | null
          client_id: string
          coach_id: string
          created_at: string
          id: string
          minutes: number
          starts_at: string
          topic: string | null
          updated_at: string
        }
        Insert: {
          cancelled_at?: string | null
          client_id: string
          coach_id: string
          created_at?: string
          id?: string
          minutes: number
          starts_at: string
          topic?: string | null
          updated_at?: string
        }
        Update: {
          cancelled_at?: string | null
          client_id?: string
          coach_id?: string
          created_at?: string
          id?: string
          minutes?: number
          starts_at?: string
          topic?: string | null
          updated_at?: string
        }
        Relationships: []
      }
      coach_client_notes: {
        Row: {
          body: string
          coach_client_id: string
          updated_at: string
        }
        Insert: {
          body?: string
          coach_client_id: string
          updated_at?: string
        }
        Update: {
          body?: string
          coach_client_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_client_notes_coach_client_id_fkey"
            columns: ["coach_client_id"]
            isOneToOne: true
            referencedRelation: "coach_clients"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_clients: {
        Row: {
          accepted_at: string | null
          auto_apply_next_week: boolean
          block_name: string | null
          block_starts_on: string | null
          block_weeks: number | null
          client_id: string | null
          coach_id: string
          created_at: string
          ended_at: string | null
          id: string
          invite_token: string | null
          invite_token_expires_at: string
          invited_email: string | null
          invited_first_name: string | null
          invited_last_name: string | null
          status: string
          visible_range: string
        }
        Insert: {
          accepted_at?: string | null
          auto_apply_next_week?: boolean
          block_name?: string | null
          block_starts_on?: string | null
          block_weeks?: number | null
          client_id?: string | null
          coach_id: string
          created_at?: string
          ended_at?: string | null
          id?: string
          invite_token?: string | null
          invite_token_expires_at?: string
          invited_email?: string | null
          invited_first_name?: string | null
          invited_last_name?: string | null
          status?: string
          visible_range?: string
        }
        Update: {
          accepted_at?: string | null
          auto_apply_next_week?: boolean
          block_name?: string | null
          block_starts_on?: string | null
          block_weeks?: number | null
          client_id?: string | null
          coach_id?: string
          created_at?: string
          ended_at?: string | null
          id?: string
          invite_token?: string | null
          invite_token_expires_at?: string
          invited_email?: string | null
          invited_first_name?: string | null
          invited_last_name?: string | null
          status?: string
          visible_range?: string
        }
        Relationships: []
      }
      coach_comment_reports: {
        Row: {
          comment_id: string
          created_at: string
          id: string
          note: string | null
          reason: string
          reporter_id: string
        }
        Insert: {
          comment_id: string
          created_at?: string
          id?: string
          note?: string | null
          reason: string
          reporter_id?: string
        }
        Update: {
          comment_id?: string
          created_at?: string
          id?: string
          note?: string | null
          reason?: string
          reporter_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_comment_reports_comment_id_fkey"
            columns: ["comment_id"]
            isOneToOne: false
            referencedRelation: "coach_post_comments"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_deload_proposals: {
        Row: {
          client_id: string
          coach_id: string
          created_at: string
          decided: string | null
          decided_at: string | null
          reason: string
          week_start: string
        }
        Insert: {
          client_id: string
          coach_id: string
          created_at?: string
          decided?: string | null
          decided_at?: string | null
          reason: string
          week_start: string
        }
        Update: {
          client_id?: string
          coach_id?: string
          created_at?: string
          decided?: string | null
          decided_at?: string | null
          reason?: string
          week_start?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_deload_proposals_client_id_fkey"
            columns: ["client_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_deload_proposals_coach_id_fkey"
            columns: ["coach_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_equipment: {
        Row: {
          coach_id: string
          created_at: string
          group_name: string | null
          hidden: boolean
          icon_path: string | null
          id: string
          key: string
          name: string | null
        }
        Insert: {
          coach_id?: string
          created_at?: string
          group_name?: string | null
          hidden?: boolean
          icon_path?: string | null
          id?: string
          key: string
          name?: string | null
        }
        Update: {
          coach_id?: string
          created_at?: string
          group_name?: string | null
          hidden?: boolean
          icon_path?: string | null
          id?: string
          key?: string
          name?: string | null
        }
        Relationships: []
      }
      coach_exercise_engine: {
        Row: {
          category: string
          coach_exercise_id: string
          confirmed_at: string
          difficulty_level: number
          engine_use: boolean
          equipment: string[]
          exercise_type: Database["public"]["Enums"]["exercise_type"]
          goals_served: string[]
          injury_contraindications: Json
          is_hold: boolean
          is_unilateral: boolean | null
          ladder: string | null
          mobility_drill_kind: string | null
          movement_pattern: Database["public"]["Enums"]["movement_pattern"]
          movement_pattern_id: string
          primary_muscles: string[]
          source: string
        }
        Insert: {
          category: string
          coach_exercise_id: string
          confirmed_at?: string
          difficulty_level: number
          engine_use?: boolean
          equipment: string[]
          exercise_type: Database["public"]["Enums"]["exercise_type"]
          goals_served: string[]
          injury_contraindications: Json
          is_hold: boolean
          is_unilateral?: boolean | null
          ladder?: string | null
          mobility_drill_kind?: string | null
          movement_pattern: Database["public"]["Enums"]["movement_pattern"]
          movement_pattern_id: string
          primary_muscles: string[]
          source: string
        }
        Update: {
          category?: string
          coach_exercise_id?: string
          confirmed_at?: string
          difficulty_level?: number
          engine_use?: boolean
          equipment?: string[]
          exercise_type?: Database["public"]["Enums"]["exercise_type"]
          goals_served?: string[]
          injury_contraindications?: Json
          is_hold?: boolean
          is_unilateral?: boolean | null
          ladder?: string | null
          mobility_drill_kind?: string | null
          movement_pattern?: Database["public"]["Enums"]["movement_pattern"]
          movement_pattern_id?: string
          primary_muscles?: string[]
          source?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_exercise_engine_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: true
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_exercises: {
        Row: {
          body_is_load: boolean
          catalog_exercise_id: string | null
          catalog_link_source: string | null
          category: string | null
          coach_id: string
          created_at: string
          demo_video_source: string | null
          demo_video_url: string | null
          difficulty: number | null
          equipment: string[]
          hidden_at: string | null
          id: string
          instructions: string[]
          instructions_source: string | null
          is_hold: boolean
          is_quality_limited: boolean | null
          movement_pattern: string | null
          name: string
          notes: string | null
          one_rm_enabled: boolean
          primary_muscles: string[]
          progress_views: string[]
          progression_config: Json | null
          starter_key: string | null
          thumbnail_url: string | null
          tips: string[]
          tracking_fields: string[]
          typical_hold_seconds_max: number | null
          typical_hold_seconds_min: number | null
          typical_rep_range_max: number | null
          typical_rep_range_min: number | null
          updated_at: string
        }
        Insert: {
          body_is_load?: boolean
          catalog_exercise_id?: string | null
          catalog_link_source?: string | null
          category?: string | null
          coach_id: string
          created_at?: string
          demo_video_source?: string | null
          demo_video_url?: string | null
          difficulty?: number | null
          equipment?: string[]
          hidden_at?: string | null
          id?: string
          instructions?: string[]
          instructions_source?: string | null
          is_hold?: boolean
          is_quality_limited?: boolean | null
          movement_pattern?: string | null
          name: string
          notes?: string | null
          one_rm_enabled?: boolean
          primary_muscles?: string[]
          progress_views?: string[]
          progression_config?: Json | null
          starter_key?: string | null
          thumbnail_url?: string | null
          tips?: string[]
          tracking_fields?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
          updated_at?: string
        }
        Update: {
          body_is_load?: boolean
          catalog_exercise_id?: string | null
          catalog_link_source?: string | null
          category?: string | null
          coach_id?: string
          created_at?: string
          demo_video_source?: string | null
          demo_video_url?: string | null
          difficulty?: number | null
          equipment?: string[]
          hidden_at?: string | null
          id?: string
          instructions?: string[]
          instructions_source?: string | null
          is_hold?: boolean
          is_quality_limited?: boolean | null
          movement_pattern?: string | null
          name?: string
          notes?: string | null
          one_rm_enabled?: boolean
          primary_muscles?: string[]
          progress_views?: string[]
          progression_config?: Json | null
          starter_key?: string | null
          thumbnail_url?: string | null
          tips?: string[]
          tracking_fields?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_exercises_catalog_exercise_id_fkey"
            columns: ["catalog_exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_follows: {
        Row: {
          coach_id: string
          created_at: string
          follower_id: string
        }
        Insert: {
          coach_id: string
          created_at?: string
          follower_id?: string
        }
        Update: {
          coach_id?: string
          created_at?: string
          follower_id?: string
        }
        Relationships: []
      }
      coach_knowledge_entries: {
        Row: {
          ai_review_reason: string | null
          ai_review_verdict: string | null
          ai_reviewed_at: string | null
          applies_to_genders: string[]
          applies_to_goals: string[]
          applies_to_injuries: string[]
          applies_to_phases: string[]
          applies_to_session_types: string[]
          applies_to_training_age: string[]
          approval_original_status: string | null
          authored_by: string
          category: string
          created_at: string
          dedup_original_status: string | null
          duplicate_of: string | null
          embedded_at: string | null
          embedding: string | null
          embedding_model: string | null
          id: string
          ingestion_source_id: string | null
          injuries_original: string[] | null
          last_referenced_at: string | null
          last_reviewed_at: string | null
          phases_original: string[] | null
          principle: string
          priority: number
          rationale: string
          recal_dedup_at: string | null
          recal_dedup_group: string | null
          recal_dedup_original_status: string | null
          recal_flags: Json | null
          recal_model: string | null
          recal_note: string | null
          recal_original_category: string | null
          recal_original_priority: number | null
          recalibrated_at: string | null
          source_reference: string
          status: string
          times_referenced: number
          title: string
          updated_at: string
        }
        Insert: {
          ai_review_reason?: string | null
          ai_review_verdict?: string | null
          ai_reviewed_at?: string | null
          applies_to_genders?: string[]
          applies_to_goals?: string[]
          applies_to_injuries?: string[]
          applies_to_phases?: string[]
          applies_to_session_types?: string[]
          applies_to_training_age?: string[]
          approval_original_status?: string | null
          authored_by?: string
          category: string
          created_at?: string
          dedup_original_status?: string | null
          duplicate_of?: string | null
          embedded_at?: string | null
          embedding?: string | null
          embedding_model?: string | null
          id?: string
          ingestion_source_id?: string | null
          injuries_original?: string[] | null
          last_referenced_at?: string | null
          last_reviewed_at?: string | null
          phases_original?: string[] | null
          principle: string
          priority?: number
          rationale?: string
          recal_dedup_at?: string | null
          recal_dedup_group?: string | null
          recal_dedup_original_status?: string | null
          recal_flags?: Json | null
          recal_model?: string | null
          recal_note?: string | null
          recal_original_category?: string | null
          recal_original_priority?: number | null
          recalibrated_at?: string | null
          source_reference?: string
          status?: string
          times_referenced?: number
          title: string
          updated_at?: string
        }
        Update: {
          ai_review_reason?: string | null
          ai_review_verdict?: string | null
          ai_reviewed_at?: string | null
          applies_to_genders?: string[]
          applies_to_goals?: string[]
          applies_to_injuries?: string[]
          applies_to_phases?: string[]
          applies_to_session_types?: string[]
          applies_to_training_age?: string[]
          approval_original_status?: string | null
          authored_by?: string
          category?: string
          created_at?: string
          dedup_original_status?: string | null
          duplicate_of?: string | null
          embedded_at?: string | null
          embedding?: string | null
          embedding_model?: string | null
          id?: string
          ingestion_source_id?: string | null
          injuries_original?: string[] | null
          last_referenced_at?: string | null
          last_reviewed_at?: string | null
          phases_original?: string[] | null
          principle?: string
          priority?: number
          rationale?: string
          recal_dedup_at?: string | null
          recal_dedup_group?: string | null
          recal_dedup_original_status?: string | null
          recal_flags?: Json | null
          recal_model?: string | null
          recal_note?: string | null
          recal_original_category?: string | null
          recal_original_priority?: number | null
          recalibrated_at?: string | null
          source_reference?: string
          status?: string
          times_referenced?: number
          title?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_knowledge_entries_duplicate_of_fkey"
            columns: ["duplicate_of"]
            isOneToOne: false
            referencedRelation: "coach_knowledge_entries"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_knowledge_entries_ingestion_source_id_fkey"
            columns: ["ingestion_source_id"]
            isOneToOne: false
            referencedRelation: "ingestion_sources"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_message_hidden: {
        Row: {
          hidden_at: string
          message_id: string
          user_id: string
        }
        Insert: {
          hidden_at?: string
          message_id: string
          user_id?: string
        }
        Update: {
          hidden_at?: string
          message_id?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_message_hidden_message_id_fkey"
            columns: ["message_id"]
            isOneToOne: false
            referencedRelation: "coach_messages"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_message_reactions: {
        Row: {
          created_at: string
          emoji: string
          message_id: string
          user_id: string
        }
        Insert: {
          created_at?: string
          emoji: string
          message_id: string
          user_id: string
        }
        Update: {
          created_at?: string
          emoji?: string
          message_id?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_message_reactions_a_real_emoji"
            columns: ["emoji"]
            isOneToOne: false
            referencedRelation: "reaction_emoji"
            referencedColumns: ["emoji"]
          },
          {
            foreignKeyName: "coach_message_reactions_message_id_fkey"
            columns: ["message_id"]
            isOneToOne: false
            referencedRelation: "coach_messages"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_messages: {
        Row: {
          audio_path: string | null
          audio_seconds: number | null
          body: string
          client_id: string
          coach_exercise_id: string | null
          coach_id: string
          created_at: string
          exercise_row_id: string | null
          id: string
          kind: string
          photo_path: string | null
          read_at: string | null
          reply_to: string | null
          sender_id: string
          session_id: string | null
          video_path: string | null
          video_seconds: number | null
        }
        Insert: {
          audio_path?: string | null
          audio_seconds?: number | null
          body: string
          client_id: string
          coach_exercise_id?: string | null
          coach_id: string
          created_at?: string
          exercise_row_id?: string | null
          id?: string
          kind?: string
          photo_path?: string | null
          read_at?: string | null
          reply_to?: string | null
          sender_id: string
          session_id?: string | null
          video_path?: string | null
          video_seconds?: number | null
        }
        Update: {
          audio_path?: string | null
          audio_seconds?: number | null
          body?: string
          client_id?: string
          coach_exercise_id?: string | null
          coach_id?: string
          created_at?: string
          exercise_row_id?: string | null
          id?: string
          kind?: string
          photo_path?: string | null
          read_at?: string | null
          reply_to?: string | null
          sender_id?: string
          session_id?: string | null
          video_path?: string | null
          video_seconds?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "coach_messages_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_messages_exercise_row_id_fkey"
            columns: ["exercise_row_id"]
            isOneToOne: false
            referencedRelation: "workout_session_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_messages_reply_to_fkey"
            columns: ["reply_to"]
            isOneToOne: false
            referencedRelation: "coach_messages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_messages_session_id_fkey"
            columns: ["session_id"]
            isOneToOne: false
            referencedRelation: "workout_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_policy_cells: {
        Row: {
          confidence: string
          created_at: string
          evidence: Json | null
          goal: string | null
          id: string
          key: string
          locked: boolean
          phase: string | null
          source: string
          training_age: string | null
          value: Json
          version: number
        }
        Insert: {
          confidence?: string
          created_at?: string
          evidence?: Json | null
          goal?: string | null
          id?: string
          key: string
          locked?: boolean
          phase?: string | null
          source: string
          training_age?: string | null
          value: Json
          version: number
        }
        Update: {
          confidence?: string
          created_at?: string
          evidence?: Json | null
          goal?: string | null
          id?: string
          key?: string
          locked?: boolean
          phase?: string | null
          source?: string
          training_age?: string | null
          value?: Json
          version?: number
        }
        Relationships: [
          {
            foreignKeyName: "coach_policy_cells_version_fkey"
            columns: ["version"]
            isOneToOne: false
            referencedRelation: "coach_policy_versions"
            referencedColumns: ["version"]
          },
        ]
      }
      coach_policy_versions: {
        Row: {
          activated_at: string | null
          compiled_by: string | null
          created_at: string
          gap_report: Json | null
          id: string
          notes: string | null
          status: string
          version: number
        }
        Insert: {
          activated_at?: string | null
          compiled_by?: string | null
          created_at?: string
          gap_report?: Json | null
          id?: string
          notes?: string | null
          status?: string
          version: number
        }
        Update: {
          activated_at?: string | null
          compiled_by?: string | null
          created_at?: string
          gap_report?: Json | null
          id?: string
          notes?: string | null
          status?: string
          version?: number
        }
        Relationships: []
      }
      coach_post_comments: {
        Row: {
          author_id: string
          body: string
          created_at: string
          held_at: string | null
          id: string
          post_id: string
          removed_at: string | null
          removed_by: string | null
          removed_reason: string | null
        }
        Insert: {
          author_id?: string
          body: string
          created_at?: string
          held_at?: string | null
          id?: string
          post_id: string
          removed_at?: string | null
          removed_by?: string | null
          removed_reason?: string | null
        }
        Update: {
          author_id?: string
          body?: string
          created_at?: string
          held_at?: string | null
          id?: string
          post_id?: string
          removed_at?: string | null
          removed_by?: string | null
          removed_reason?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "coach_post_comments_post_id_fkey"
            columns: ["post_id"]
            isOneToOne: false
            referencedRelation: "coach_posts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_post_likes: {
        Row: {
          created_at: string
          post_id: string
          user_id: string
        }
        Insert: {
          created_at?: string
          post_id: string
          user_id?: string
        }
        Update: {
          created_at?: string
          post_id?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_post_likes_post_id_fkey"
            columns: ["post_id"]
            isOneToOne: false
            referencedRelation: "coach_posts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_post_reports: {
        Row: {
          created_at: string
          id: string
          note: string | null
          post_id: string
          reason: string
          reporter_id: string
        }
        Insert: {
          created_at?: string
          id?: string
          note?: string | null
          post_id: string
          reason: string
          reporter_id?: string
        }
        Update: {
          created_at?: string
          id?: string
          note?: string | null
          post_id?: string
          reason?: string
          reporter_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_post_reports_post_id_fkey"
            columns: ["post_id"]
            isOneToOne: false
            referencedRelation: "coach_posts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_posts: {
        Row: {
          author_kind: string
          body: string
          coach_id: string
          comments_enabled: boolean
          created_at: string
          held_at: string | null
          id: string
          media_kind: string | null
          media_path: string | null
          removed_at: string | null
          removed_by: string | null
          removed_reason: string | null
        }
        Insert: {
          author_kind?: string
          body: string
          coach_id: string
          comments_enabled?: boolean
          created_at?: string
          held_at?: string | null
          id?: string
          media_kind?: string | null
          media_path?: string | null
          removed_at?: string | null
          removed_by?: string | null
          removed_reason?: string | null
        }
        Update: {
          author_kind?: string
          body?: string
          coach_id?: string
          comments_enabled?: boolean
          created_at?: string
          held_at?: string | null
          id?: string
          media_kind?: string | null
          media_path?: string | null
          removed_at?: string | null
          removed_by?: string | null
          removed_reason?: string | null
        }
        Relationships: []
      }
      coach_profiles: {
        Row: {
          achievements: string[]
          avatar_url: string | null
          bio: string
          certifications: Json
          city: string
          coaching_since: string | null
          created_at: string
          display_name: string
          headline: string
          id: string
          instagram: string | null
          is_published: boolean
          schools: string[]
          updated_at: string
          website: string | null
          years_coaching: number
        }
        Insert: {
          achievements?: string[]
          avatar_url?: string | null
          bio?: string
          certifications?: Json
          city?: string
          coaching_since?: string | null
          created_at?: string
          display_name: string
          headline?: string
          id: string
          instagram?: string | null
          is_published?: boolean
          schools?: string[]
          updated_at?: string
          website?: string | null
          years_coaching?: number
        }
        Update: {
          achievements?: string[]
          avatar_url?: string | null
          bio?: string
          certifications?: Json
          city?: string
          coaching_since?: string | null
          created_at?: string
          display_name?: string
          headline?: string
          id?: string
          instagram?: string | null
          is_published?: boolean
          schools?: string[]
          updated_at?: string
          website?: string | null
          years_coaching?: number
        }
        Relationships: []
      }
      coach_program_assignments: {
        Row: {
          assigned_at: string
          client_id: string
          coach_id: string
          days_already: number
          days_planned: number
          days_written: number
          id: string
          program_id: string
          start_date: string
        }
        Insert: {
          assigned_at?: string
          client_id: string
          coach_id: string
          days_already: number
          days_planned: number
          days_written: number
          id?: string
          program_id: string
          start_date: string
        }
        Update: {
          assigned_at?: string
          client_id?: string
          coach_id?: string
          days_already?: number
          days_planned?: number
          days_written?: number
          id?: string
          program_id?: string
          start_date?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_program_assignments_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "coach_programs"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_program_days: {
        Row: {
          id: string
          note: string | null
          position: number
          program_id: string
          week_index: number
          weekday: number
          workout_id: string
        }
        Insert: {
          id?: string
          note?: string | null
          position?: number
          program_id: string
          week_index: number
          weekday: number
          workout_id: string
        }
        Update: {
          id?: string
          note?: string | null
          position?: number
          program_id?: string
          week_index?: number
          weekday?: number
          workout_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_program_days_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "coach_programs"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_program_days_workout_id_fkey"
            columns: ["workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_program_weeks: {
        Row: {
          derived: boolean
          is_deload: boolean
          program_id: string
          week_index: number
        }
        Insert: {
          derived?: boolean
          is_deload?: boolean
          program_id: string
          week_index: number
        }
        Update: {
          derived?: boolean
          is_deload?: boolean
          program_id?: string
          week_index?: number
        }
        Relationships: [
          {
            foreignKeyName: "coach_program_weeks_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "coach_programs"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_programs: {
        Row: {
          archived_at: string | null
          coach_id: string
          created_at: string
          deload_automatic: boolean
          deload_every: number | null
          description: string | null
          id: string
          name: string
          progress: boolean
          updated_at: string
        }
        Insert: {
          archived_at?: string | null
          coach_id: string
          created_at?: string
          deload_automatic?: boolean
          deload_every?: number | null
          description?: string | null
          id?: string
          name: string
          progress?: boolean
          updated_at?: string
        }
        Update: {
          archived_at?: string | null
          coach_id?: string
          created_at?: string
          deload_automatic?: boolean
          deload_every?: number | null
          description?: string | null
          id?: string
          name?: string
          progress?: boolean
          updated_at?: string
        }
        Relationships: []
      }
      coach_reminders: {
        Row: {
          client_id: string | null
          coach_id: string
          created_at: string
          done_at: string | null
          due_at: string
          id: string
          title: string
        }
        Insert: {
          client_id?: string | null
          coach_id?: string
          created_at?: string
          done_at?: string | null
          due_at: string
          id?: string
          title: string
        }
        Update: {
          client_id?: string | null
          coach_id?: string
          created_at?: string
          done_at?: string | null
          due_at?: string
          id?: string
          title?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_reminders_client_id_fkey"
            columns: ["client_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_requests: {
        Row: {
          client_email: string | null
          client_id: string
          client_name: string
          coach_id: string
          created_at: string
          decided_at: string | null
          id: string
          note: string | null
          status: string
        }
        Insert: {
          client_email?: string | null
          client_id?: string
          client_name?: string
          coach_id: string
          created_at?: string
          decided_at?: string | null
          id?: string
          note?: string | null
          status?: string
        }
        Update: {
          client_email?: string | null
          client_id?: string
          client_name?: string
          coach_id?: string
          created_at?: string
          decided_at?: string | null
          id?: string
          note?: string | null
          status?: string
        }
        Relationships: []
      }
      coach_workout_engine: {
        Row: {
          deload_every: number | null
          progress: boolean
          updated_at: string
          workout_id: string
        }
        Insert: {
          deload_every?: number | null
          progress?: boolean
          updated_at?: string
          workout_id: string
        }
        Update: {
          deload_every?: number | null
          progress?: boolean
          updated_at?: string
          workout_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_workout_engine_workout_id_fkey"
            columns: ["workout_id"]
            isOneToOne: true
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_workout_exercises: {
        Row: {
          each_side: boolean
          exercise_id: string
          hidden: boolean
          hold_seconds_max: number | null
          hold_seconds_min: number | null
          hold_until_lost: boolean
          id: string
          notes: string | null
          position: number
          reps_max: number | null
          reps_min: number | null
          rest_seconds: number | null
          section_id: string
          sets: number | null
          superset_with_next: boolean
          tempo: string | null
        }
        Insert: {
          each_side?: boolean
          exercise_id: string
          hidden?: boolean
          hold_seconds_max?: number | null
          hold_seconds_min?: number | null
          hold_until_lost?: boolean
          id?: string
          notes?: string | null
          position: number
          reps_max?: number | null
          reps_min?: number | null
          rest_seconds?: number | null
          section_id: string
          sets?: number | null
          superset_with_next?: boolean
          tempo?: string | null
        }
        Update: {
          each_side?: boolean
          exercise_id?: string
          hidden?: boolean
          hold_seconds_max?: number | null
          hold_seconds_min?: number | null
          hold_until_lost?: boolean
          id?: string
          notes?: string | null
          position?: number
          reps_max?: number | null
          reps_min?: number | null
          rest_seconds?: number | null
          section_id?: string
          sets?: number | null
          superset_with_next?: boolean
          tempo?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "coach_workout_exercises_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_workout_exercises_section_id_fkey"
            columns: ["section_id"]
            isOneToOne: false
            referencedRelation: "coach_workout_sections"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_workout_rules: {
        Row: {
          exercise_id: string
          progression_config: Json | null
          updated_at: string
          workout_id: string
        }
        Insert: {
          exercise_id: string
          progression_config?: Json | null
          updated_at?: string
          workout_id: string
        }
        Update: {
          exercise_id?: string
          progression_config?: Json | null
          updated_at?: string
          workout_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_workout_rules_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "coach_workout_rules_workout_id_fkey"
            columns: ["workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_workout_sections: {
        Row: {
          description: string | null
          format: string
          format_config: Json | null
          id: string
          is_implicit: boolean
          name: string | null
          position: number
          reminder_times: number[]
          section_type: string
          workout_id: string
        }
        Insert: {
          description?: string | null
          format?: string
          format_config?: Json | null
          id?: string
          is_implicit?: boolean
          name?: string | null
          position: number
          reminder_times?: number[]
          section_type?: string
          workout_id: string
        }
        Update: {
          description?: string | null
          format?: string
          format_config?: Json | null
          id?: string
          is_implicit?: boolean
          name?: string | null
          position?: number
          reminder_times?: number[]
          section_type?: string
          workout_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_workout_sections_workout_id_fkey"
            columns: ["workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_workout_sets: {
        Row: {
          distance_m: number | null
          id: string
          position: number
          reps: number | null
          rest_seconds: number | null
          rounds: number | null
          set_type: string
          time_seconds: number | null
          weight_kg: number | null
          workout_exercise_id: string
        }
        Insert: {
          distance_m?: number | null
          id?: string
          position: number
          reps?: number | null
          rest_seconds?: number | null
          rounds?: number | null
          set_type?: string
          time_seconds?: number | null
          weight_kg?: number | null
          workout_exercise_id: string
        }
        Update: {
          distance_m?: number | null
          id?: string
          position?: number
          reps?: number | null
          rest_seconds?: number | null
          rounds?: number | null
          set_type?: string
          time_seconds?: number | null
          weight_kg?: number | null
          workout_exercise_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_workout_sets_workout_exercise_id_fkey"
            columns: ["workout_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_workout_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      coach_workouts: {
        Row: {
          archived_at: string | null
          check_in_fields: string[] | null
          client_id: string | null
          coach_id: string
          created_at: string
          description: string | null
          id: string
          kind: string
          name: string
          root_workout_id: string | null
          task_optional: boolean
          task_prompt: string | null
          updated_at: string
        }
        Insert: {
          archived_at?: string | null
          check_in_fields?: string[] | null
          client_id?: string | null
          coach_id: string
          created_at?: string
          description?: string | null
          id?: string
          kind?: string
          name: string
          root_workout_id?: string | null
          task_optional?: boolean
          task_prompt?: string | null
          updated_at?: string
        }
        Update: {
          archived_at?: string | null
          check_in_fields?: string[] | null
          client_id?: string | null
          coach_id?: string
          created_at?: string
          description?: string | null
          id?: string
          kind?: string
          name?: string
          root_workout_id?: string | null
          task_optional?: boolean
          task_prompt?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "coach_workouts_root_workout_id_fkey"
            columns: ["root_workout_id"]
            isOneToOne: false
            referencedRelation: "coach_workouts"
            referencedColumns: ["id"]
          },
        ]
      }
      community_identities: {
        Row: {
          allows_messages: boolean
          avatar_url: string | null
          comments_enabled: boolean
          created_at: string
          display_name: string
          id: string
          is_reachable: boolean | null
          is_visible: boolean
          updated_at: string
        }
        Insert: {
          allows_messages: boolean
          avatar_url?: string | null
          comments_enabled?: boolean
          created_at?: string
          display_name: string
          id?: string
          is_reachable?: boolean | null
          is_visible: boolean
          updated_at?: string
        }
        Update: {
          allows_messages?: boolean
          avatar_url?: string | null
          comments_enabled?: boolean
          created_at?: string
          display_name?: string
          id?: string
          is_reachable?: boolean | null
          is_visible?: boolean
          updated_at?: string
        }
        Relationships: []
      }
      daily_feedback: {
        Row: {
          ai_adjustments: Json | null
          created_at: string | null
          energy_level: number
          feedback_date: string
          id: string
          notes: string
          overall_feeling: number
          session_id: string | null
          soreness_map: Json
          user_id: string
        }
        Insert: {
          ai_adjustments?: Json | null
          created_at?: string | null
          energy_level?: number
          feedback_date?: string
          id?: string
          notes?: string
          overall_feeling?: number
          session_id?: string | null
          soreness_map?: Json
          user_id: string
        }
        Update: {
          ai_adjustments?: Json | null
          created_at?: string | null
          energy_level?: number
          feedback_date?: string
          id?: string
          notes?: string
          overall_feeling?: number
          session_id?: string | null
          soreness_map?: Json
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "daily_feedback_session_id_fkey"
            columns: ["session_id"]
            isOneToOne: false
            referencedRelation: "workout_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      data_exports: {
        Row: {
          bytes: number | null
          client_id: string | null
          coach_id: string
          completed_at: string | null
          id: string
          kind: string
          requested_at: string
        }
        Insert: {
          bytes?: number | null
          client_id?: string | null
          coach_id?: string
          completed_at?: string | null
          id?: string
          kind: string
          requested_at?: string
        }
        Update: {
          bytes?: number | null
          client_id?: string | null
          coach_id?: string
          completed_at?: string | null
          id?: string
          kind?: string
          requested_at?: string
        }
        Relationships: []
      }
      device_push_tokens: {
        Row: {
          app_build: string | null
          created_at: string
          disabled_at: string | null
          disabled_reason: string | null
          environment: string
          id: string
          last_registered_at: string
          platform: string
          token: string
          topic: string | null
          user_id: string
        }
        Insert: {
          app_build?: string | null
          created_at?: string
          disabled_at?: string | null
          disabled_reason?: string | null
          environment: string
          id?: string
          last_registered_at?: string
          platform?: string
          token: string
          topic?: string | null
          user_id: string
        }
        Update: {
          app_build?: string | null
          created_at?: string
          disabled_at?: string | null
          disabled_reason?: string | null
          environment?: string
          id?: string
          last_registered_at?: string
          platform?: string
          token?: string
          topic?: string | null
          user_id?: string
        }
        Relationships: []
      }
      engine_events: {
        Row: {
          created_at: string
          engine_version: string | null
          id: string
          kind: string
          payload: Json
          rules_version: number | null
          user_id: string
        }
        Insert: {
          created_at?: string
          engine_version?: string | null
          id?: string
          kind: string
          payload: Json
          rules_version?: number | null
          user_id: string
        }
        Update: {
          created_at?: string
          engine_version?: string | null
          id?: string
          kind?: string
          payload?: Json
          rules_version?: number | null
          user_id?: string
        }
        Relationships: []
      }
      equipment: {
        Row: {
          display_name: string
          group_id: string
          id: string
          is_ambient: boolean
        }
        Insert: {
          display_name: string
          group_id: string
          id: string
          is_ambient?: boolean
        }
        Update: {
          display_name?: string
          group_id?: string
          id?: string
          is_ambient?: boolean
        }
        Relationships: [
          {
            foreignKeyName: "equipment_group_id_fkey"
            columns: ["group_id"]
            isOneToOne: false
            referencedRelation: "equipment_groups"
            referencedColumns: ["id"]
          },
        ]
      }
      equipment_groups: {
        Row: {
          display_name: string
          id: string
        }
        Insert: {
          display_name: string
          id: string
        }
        Update: {
          display_name?: string
          id?: string
        }
        Relationships: []
      }
      exercise_categories: {
        Row: {
          id: string
        }
        Insert: {
          id: string
        }
        Update: {
          id?: string
        }
        Relationships: []
      }
      exercise_cost: {
        Row: {
          axial_load: number | null
          connective_tissue_cost: number | null
          derived_at: string | null
          exercise_id: string
          flags: Json | null
          model: string | null
          note: string | null
          stability_demand: number | null
          systemic_cost: number | null
        }
        Insert: {
          axial_load?: number | null
          connective_tissue_cost?: number | null
          derived_at?: string | null
          exercise_id: string
          flags?: Json | null
          model?: string | null
          note?: string | null
          stability_demand?: number | null
          systemic_cost?: number | null
        }
        Update: {
          axial_load?: number | null
          connective_tissue_cost?: number | null
          derived_at?: string | null
          exercise_id?: string
          flags?: Json | null
          model?: string | null
          note?: string | null
          stability_demand?: number | null
          systemic_cost?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "exercise_cost_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: true
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_coverage: {
        Row: {
          coach_exercise_id: string | null
          contraction: string
          created_at: string
          exercise_id: string | null
          id: string
          joint_action: string
          muscles: string[]
          note: string
          provenance: string
          role: string
          zone: string
        }
        Insert: {
          coach_exercise_id?: string | null
          contraction: string
          created_at?: string
          exercise_id?: string | null
          id?: string
          joint_action: string
          muscles?: string[]
          note?: string
          provenance: string
          role: string
          zone: string
        }
        Update: {
          coach_exercise_id?: string | null
          contraction?: string
          created_at?: string
          exercise_id?: string | null
          id?: string
          joint_action?: string
          muscles?: string[]
          note?: string
          provenance?: string
          role?: string
          zone?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_coverage_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_coverage_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_edges: {
        Row: {
          from_id: string
          kind: string
          to_id: string
        }
        Insert: {
          from_id: string
          kind: string
          to_id: string
        }
        Update: {
          from_id?: string
          kind?: string
          to_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_edges_from_id_fkey"
            columns: ["from_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_edges_to_id_fkey"
            columns: ["to_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_equipment: {
        Row: {
          equipment_id: string
          exercise_id: string
          requirement: string
        }
        Insert: {
          equipment_id: string
          exercise_id: string
          requirement?: string
        }
        Update: {
          equipment_id?: string
          exercise_id?: string
          requirement?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_equipment_equipment_id_fkey"
            columns: ["equipment_id"]
            isOneToOne: false
            referencedRelation: "equipment"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_equipment_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_field_provenance: {
        Row: {
          citation: string | null
          confidence: string
          decided_at: string
          decided_by: string
          exercise_id: string
          field_path: string
          model: string | null
          source: string
        }
        Insert: {
          citation?: string | null
          confidence: string
          decided_at?: string
          decided_by: string
          exercise_id: string
          field_path: string
          model?: string | null
          source: string
        }
        Update: {
          citation?: string | null
          confidence?: string
          decided_at?: string
          decided_by?: string
          exercise_id?: string
          field_path?: string
          model?: string | null
          source?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_field_provenance_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_field_second_opinion: {
        Row: {
          agrees: boolean
          decided_at: string
          delta: number | null
          exercise_id: string
          field_path: string
          model: string
          pass1_confidence: string
          pass1_value: Json
          pass2_confidence: string
          pass2_mechanics: string | null
          pass2_note: string | null
          pass2_value: Json
          severity: string
        }
        Insert: {
          agrees: boolean
          decided_at?: string
          delta?: number | null
          exercise_id: string
          field_path: string
          model: string
          pass1_confidence: string
          pass1_value: Json
          pass2_confidence: string
          pass2_mechanics?: string | null
          pass2_note?: string | null
          pass2_value: Json
          severity: string
        }
        Update: {
          agrees?: boolean
          decided_at?: string
          delta?: number | null
          exercise_id?: string
          field_path?: string
          model?: string
          pass1_confidence?: string
          pass1_value?: Json
          pass2_confidence?: string
          pass2_mechanics?: string | null
          pass2_note?: string | null
          pass2_value?: Json
          severity?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_field_second_opinion_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_goals: {
        Row: {
          exercise_id: string
          goal_tag_id: string
        }
        Insert: {
          exercise_id: string
          goal_tag_id: string
        }
        Update: {
          exercise_id?: string
          goal_tag_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_goals_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_goals_goal_tag_id_fkey"
            columns: ["goal_tag_id"]
            isOneToOne: false
            referencedRelation: "goal_tags"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_injuries: {
        Row: {
          condition_id: string
          exercise_id: string
          note: string | null
          relation: string
        }
        Insert: {
          condition_id: string
          exercise_id: string
          note?: string | null
          relation: string
        }
        Update: {
          condition_id?: string
          exercise_id?: string
          note?: string | null
          relation?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_injuries_condition_id_fkey"
            columns: ["condition_id"]
            isOneToOne: false
            referencedRelation: "injury_conditions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_injuries_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_muscles: {
        Row: {
          contribution: number | null
          exercise_id: string
          muscle_id: string
          provenance: string
          reviewed_at: string | null
          role: string
        }
        Insert: {
          contribution?: number | null
          exercise_id: string
          muscle_id: string
          provenance?: string
          reviewed_at?: string | null
          role: string
        }
        Update: {
          contribution?: number | null
          exercise_id?: string
          muscle_id?: string
          provenance?: string
          reviewed_at?: string | null
          role?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_muscles_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_muscles_muscle_id_fkey"
            columns: ["muscle_id"]
            isOneToOne: false
            referencedRelation: "muscles"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_pr_history: {
        Row: {
          achieved_at: string
          coach_exercise_id: string | null
          context_note: string
          created_at: string
          exercise_id: string | null
          id: string
          pr_type: string
          user_id: string
          value_numeric: number
          value_unit: string
          workout_session_exercise_id: string | null
        }
        Insert: {
          achieved_at?: string
          coach_exercise_id?: string | null
          context_note?: string
          created_at?: string
          exercise_id?: string | null
          id?: string
          pr_type: string
          user_id: string
          value_numeric: number
          value_unit: string
          workout_session_exercise_id?: string | null
        }
        Update: {
          achieved_at?: string
          coach_exercise_id?: string | null
          context_note?: string
          created_at?: string
          exercise_id?: string | null
          id?: string
          pr_type?: string
          user_id?: string
          value_numeric?: number
          value_unit?: string
          workout_session_exercise_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "exercise_pr_history_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_pr_history_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_pr_history_workout_session_exercise_id_fkey"
            columns: ["workout_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "workout_session_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_reasoning_expansions: {
        Row: {
          created_at: string
          expanded_reasoning: string
          generated_with_model: string
          id: string
          input_tokens: number
          output_tokens: number
          program_session_exercise_id: string
          short_reason: string
          user_id: string
        }
        Insert: {
          created_at?: string
          expanded_reasoning: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          output_tokens?: number
          program_session_exercise_id: string
          short_reason: string
          user_id: string
        }
        Update: {
          created_at?: string
          expanded_reasoning?: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          output_tokens?: number
          program_session_exercise_id?: string
          short_reason?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_reasoning_expansions_program_session_exercise_id_fkey"
            columns: ["program_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "program_session_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      exercise_user_state: {
        Row: {
          best_hold_seconds: number | null
          best_reps_at_bodyweight: number | null
          best_weight_for_reps_at_reps: number | null
          best_weight_for_reps_kg: number | null
          created_at: string
          exercise_id: string
          first_performed_at: string | null
          id: string
          last_performed_at: string | null
          latest_equipment_id: string | null
          latest_hold_seconds: number | null
          latest_modifier_label: string
          latest_modifier_value_numeric: number | null
          latest_note: string
          latest_reps: number | null
          latest_rpe: number | null
          latest_weight_kg: number | null
          times_performed: number
          total_sets_logged: number
          updated_at: string
          user_id: string
        }
        Insert: {
          best_hold_seconds?: number | null
          best_reps_at_bodyweight?: number | null
          best_weight_for_reps_at_reps?: number | null
          best_weight_for_reps_kg?: number | null
          created_at?: string
          exercise_id: string
          first_performed_at?: string | null
          id?: string
          last_performed_at?: string | null
          latest_equipment_id?: string | null
          latest_hold_seconds?: number | null
          latest_modifier_label?: string
          latest_modifier_value_numeric?: number | null
          latest_note?: string
          latest_reps?: number | null
          latest_rpe?: number | null
          latest_weight_kg?: number | null
          times_performed?: number
          total_sets_logged?: number
          updated_at?: string
          user_id: string
        }
        Update: {
          best_hold_seconds?: number | null
          best_reps_at_bodyweight?: number | null
          best_weight_for_reps_at_reps?: number | null
          best_weight_for_reps_kg?: number | null
          created_at?: string
          exercise_id?: string
          first_performed_at?: string | null
          id?: string
          last_performed_at?: string | null
          latest_equipment_id?: string | null
          latest_hold_seconds?: number | null
          latest_modifier_label?: string
          latest_modifier_value_numeric?: number | null
          latest_note?: string
          latest_reps?: number | null
          latest_rpe?: number | null
          latest_weight_kg?: number | null
          times_performed?: number
          total_sets_logged?: number
          updated_at?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "exercise_user_state_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercise_user_state_latest_equipment_id_fkey"
            columns: ["latest_equipment_id"]
            isOneToOne: false
            referencedRelation: "user_equipment"
            referencedColumns: ["id"]
          },
        ]
      }
      exercises: {
        Row: {
          ai_review_reason: string | null
          ai_review_verdict: string | null
          ai_reviewed_at: string | null
          alternative_ids: string[]
          arm_derived_at: string | null
          arm_model: string | null
          attr_derived_at: string | null
          attr_flags: Json | null
          attr_model: string | null
          attr_note: string | null
          available_modifier_categories: string[]
          avg_actual_seconds_per_rep: number | null
          avg_user_rpe: number | null
          category: string
          category_id: string | null
          coach_notes: string | null
          common_mistakes: string[]
          contraction_type: string | null
          contraindications: string[]
          created_at: string | null
          created_by: string | null
          dedup_original_status: string | null
          default_seconds_per_rep: number | null
          default_tempo: string | null
          demo_video_source: string | null
          demo_video_url: string | null
          description: string
          difficulty: string
          difficulty_level: number | null
          duplicate_of: string | null
          equipment: string[]
          equipment_original: string[] | null
          exercise_type: Database["public"]["Enums"]["exercise_type"] | null
          form_cues: string[]
          goals_served: string[]
          id: string
          identity_aliases: string[]
          ingestion_source_id: string | null
          injury_cautions: Json
          injury_contraindications: Json
          injury_therapeutic: string[]
          instructions: string[]
          is_axially_loaded: boolean | null
          is_hold: boolean
          is_published: boolean
          is_straight_arm: boolean | null
          is_unilateral: boolean | null
          joints_involved: string[]
          last_reviewed_by_admin: string | null
          laterality: string | null
          load_basis: string | null
          loading_type: Database["public"]["Enums"]["loading_type"] | null
          loads_grip: boolean | null
          loads_pronation_supination: boolean | null
          mechanic: string | null
          mobility_drill_kind: string | null
          movement_pattern:
            | Database["public"]["Enums"]["movement_pattern"]
            | null
          movement_pattern_id: string | null
          movement_plane: Database["public"]["Enums"]["movement_plane"] | null
          muscle_groups: string[]
          name: string
          name_original: string | null
          owner_id: string | null
          prerequisite_ids: string[]
          prescription_kind: string | null
          primary_muscles: string[]
          prog_derived_at: string | null
          prog_flags: Json | null
          prog_model: string | null
          prog_note: string | null
          progression_ids: string[]
          regression_ids: string[]
          retired_reason: string | null
          review_status: Database["public"]["Enums"]["review_status"]
          sample_size: number
          secondary_muscles: string[]
          slug: string | null
          stability_demand: number | null
          stall_rate: number | null
          status: string | null
          tags: string[]
          tempo_seconds_per_rep: number | null
          thumbnail_url: string | null
          tips: string[]
          typical_hold_seconds_max: number | null
          typical_hold_seconds_min: number | null
          typical_rep_range_max: number | null
          typical_rep_range_min: number | null
          updated_at: string | null
          verified_by_owner_at: string | null
        }
        Insert: {
          ai_review_reason?: string | null
          ai_review_verdict?: string | null
          ai_reviewed_at?: string | null
          alternative_ids?: string[]
          arm_derived_at?: string | null
          arm_model?: string | null
          attr_derived_at?: string | null
          attr_flags?: Json | null
          attr_model?: string | null
          attr_note?: string | null
          available_modifier_categories?: string[]
          avg_actual_seconds_per_rep?: number | null
          avg_user_rpe?: number | null
          category: string
          category_id?: string | null
          coach_notes?: string | null
          common_mistakes?: string[]
          contraction_type?: string | null
          contraindications?: string[]
          created_at?: string | null
          created_by?: string | null
          dedup_original_status?: string | null
          default_seconds_per_rep?: number | null
          default_tempo?: string | null
          demo_video_source?: string | null
          demo_video_url?: string | null
          description?: string
          difficulty?: string
          difficulty_level?: number | null
          duplicate_of?: string | null
          equipment?: string[]
          equipment_original?: string[] | null
          exercise_type?: Database["public"]["Enums"]["exercise_type"] | null
          form_cues?: string[]
          goals_served?: string[]
          id?: string
          identity_aliases?: string[]
          ingestion_source_id?: string | null
          injury_cautions?: Json
          injury_contraindications?: Json
          injury_therapeutic?: string[]
          instructions?: string[]
          is_axially_loaded?: boolean | null
          is_hold?: boolean
          is_published?: boolean
          is_straight_arm?: boolean | null
          is_unilateral?: boolean | null
          joints_involved?: string[]
          last_reviewed_by_admin?: string | null
          laterality?: string | null
          load_basis?: string | null
          loading_type?: Database["public"]["Enums"]["loading_type"] | null
          loads_grip?: boolean | null
          loads_pronation_supination?: boolean | null
          mechanic?: string | null
          mobility_drill_kind?: string | null
          movement_pattern?:
            | Database["public"]["Enums"]["movement_pattern"]
            | null
          movement_pattern_id?: string | null
          movement_plane?: Database["public"]["Enums"]["movement_plane"] | null
          muscle_groups?: string[]
          name: string
          name_original?: string | null
          owner_id?: string | null
          prerequisite_ids?: string[]
          prescription_kind?: string | null
          primary_muscles?: string[]
          prog_derived_at?: string | null
          prog_flags?: Json | null
          prog_model?: string | null
          prog_note?: string | null
          progression_ids?: string[]
          regression_ids?: string[]
          retired_reason?: string | null
          review_status?: Database["public"]["Enums"]["review_status"]
          sample_size?: number
          secondary_muscles?: string[]
          slug?: string | null
          stability_demand?: number | null
          stall_rate?: number | null
          status?: string | null
          tags?: string[]
          tempo_seconds_per_rep?: number | null
          thumbnail_url?: string | null
          tips?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
          updated_at?: string | null
          verified_by_owner_at?: string | null
        }
        Update: {
          ai_review_reason?: string | null
          ai_review_verdict?: string | null
          ai_reviewed_at?: string | null
          alternative_ids?: string[]
          arm_derived_at?: string | null
          arm_model?: string | null
          attr_derived_at?: string | null
          attr_flags?: Json | null
          attr_model?: string | null
          attr_note?: string | null
          available_modifier_categories?: string[]
          avg_actual_seconds_per_rep?: number | null
          avg_user_rpe?: number | null
          category?: string
          category_id?: string | null
          coach_notes?: string | null
          common_mistakes?: string[]
          contraction_type?: string | null
          contraindications?: string[]
          created_at?: string | null
          created_by?: string | null
          dedup_original_status?: string | null
          default_seconds_per_rep?: number | null
          default_tempo?: string | null
          demo_video_source?: string | null
          demo_video_url?: string | null
          description?: string
          difficulty?: string
          difficulty_level?: number | null
          duplicate_of?: string | null
          equipment?: string[]
          equipment_original?: string[] | null
          exercise_type?: Database["public"]["Enums"]["exercise_type"] | null
          form_cues?: string[]
          goals_served?: string[]
          id?: string
          identity_aliases?: string[]
          ingestion_source_id?: string | null
          injury_cautions?: Json
          injury_contraindications?: Json
          injury_therapeutic?: string[]
          instructions?: string[]
          is_axially_loaded?: boolean | null
          is_hold?: boolean
          is_published?: boolean
          is_straight_arm?: boolean | null
          is_unilateral?: boolean | null
          joints_involved?: string[]
          last_reviewed_by_admin?: string | null
          laterality?: string | null
          load_basis?: string | null
          loading_type?: Database["public"]["Enums"]["loading_type"] | null
          loads_grip?: boolean | null
          loads_pronation_supination?: boolean | null
          mechanic?: string | null
          mobility_drill_kind?: string | null
          movement_pattern?:
            | Database["public"]["Enums"]["movement_pattern"]
            | null
          movement_pattern_id?: string | null
          movement_plane?: Database["public"]["Enums"]["movement_plane"] | null
          muscle_groups?: string[]
          name?: string
          name_original?: string | null
          owner_id?: string | null
          prerequisite_ids?: string[]
          prescription_kind?: string | null
          primary_muscles?: string[]
          prog_derived_at?: string | null
          prog_flags?: Json | null
          prog_model?: string | null
          prog_note?: string | null
          progression_ids?: string[]
          regression_ids?: string[]
          retired_reason?: string | null
          review_status?: Database["public"]["Enums"]["review_status"]
          sample_size?: number
          secondary_muscles?: string[]
          slug?: string | null
          stability_demand?: number | null
          stall_rate?: number | null
          status?: string | null
          tags?: string[]
          tempo_seconds_per_rep?: number | null
          thumbnail_url?: string | null
          tips?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
          updated_at?: string | null
          verified_by_owner_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "exercises_category_id_fkey"
            columns: ["category_id"]
            isOneToOne: false
            referencedRelation: "exercise_categories"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercises_ingestion_source_id_fkey"
            columns: ["ingestion_source_id"]
            isOneToOne: false
            referencedRelation: "ingestion_sources"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exercises_movement_pattern_id_fkey"
            columns: ["movement_pattern_id"]
            isOneToOne: false
            referencedRelation: "movement_patterns"
            referencedColumns: ["id"]
          },
        ]
      }
      form_clips: {
        Row: {
          auto_counted_reps: number | null
          counted_reps: number | null
          duration_seconds: number | null
          expires_at: string
          id: string
          media_kind: string
          pose_source: string
          position: number | null
          recorded_at: string
          set_number: number
          storage_path: string
          trim_end_seconds: number | null
          trim_source: string
          trim_start_seconds: number
          user_id: string
          workout_session_exercise_id: string
        }
        Insert: {
          auto_counted_reps?: number | null
          counted_reps?: number | null
          duration_seconds?: number | null
          expires_at: string
          id: string
          media_kind?: string
          pose_source: string
          position?: number | null
          recorded_at?: string
          set_number: number
          storage_path: string
          trim_end_seconds?: number | null
          trim_source: string
          trim_start_seconds?: number
          user_id: string
          workout_session_exercise_id: string
        }
        Update: {
          auto_counted_reps?: number | null
          counted_reps?: number | null
          duration_seconds?: number | null
          expires_at?: string
          id?: string
          media_kind?: string
          pose_source?: string
          position?: number | null
          recorded_at?: string
          set_number?: number
          storage_path?: string
          trim_end_seconds?: number | null
          trim_source?: string
          trim_start_seconds?: number
          user_id?: string
          workout_session_exercise_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "form_clips_workout_session_exercise_id_fkey"
            columns: ["workout_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "workout_session_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      founder_stamps: {
        Row: {
          coach_id: string
          cohort: string
          note: string
          pays_percent_of_list: number
          seat: number
          stamped_at: string
        }
        Insert: {
          coach_id: string
          cohort?: string
          note?: string
          pays_percent_of_list?: number
          seat: number
          stamped_at?: string
        }
        Update: {
          coach_id?: string
          cohort?: string
          note?: string
          pays_percent_of_list?: number
          seat?: number
          stamped_at?: string
        }
        Relationships: []
      }
      goal_tags: {
        Row: {
          athlete_selectable: boolean
          id: string
        }
        Insert: {
          athlete_selectable?: boolean
          id: string
        }
        Update: {
          athlete_selectable?: boolean
          id?: string
        }
        Relationships: []
      }
      health_data_consents: {
        Row: {
          answer: string
          id: number
          platform: string
          recorded_at: string
          user_id: string
          wording_version: string
        }
        Insert: {
          answer: string
          id?: never
          platform: string
          recorded_at?: string
          user_id?: string
          wording_version: string
        }
        Update: {
          answer?: string
          id?: never
          platform?: string
          recorded_at?: string
          user_id?: string
          wording_version?: string
        }
        Relationships: []
      }
      ingestion_chunks: {
        Row: {
          chunk_index: number
          chunk_title: string | null
          content: string
          created_at: string
          extraction_status: string
          id: string
          source_id: string
          word_count: number | null
        }
        Insert: {
          chunk_index: number
          chunk_title?: string | null
          content: string
          created_at?: string
          extraction_status?: string
          id?: string
          source_id: string
          word_count?: number | null
        }
        Update: {
          chunk_index?: number
          chunk_title?: string | null
          content?: string
          created_at?: string
          extraction_status?: string
          id?: string
          source_id?: string
          word_count?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "ingestion_chunks_source_id_fkey"
            columns: ["source_id"]
            isOneToOne: false
            referencedRelation: "ingestion_sources"
            referencedColumns: ["id"]
          },
        ]
      }
      ingestion_sources: {
        Row: {
          author: string | null
          chunk_count: number
          created_at: string
          extraction_completed_at: string | null
          extraction_started_at: string | null
          id: string
          notes: string | null
          source_type: string | null
          status: string
          storage_path: string | null
          title: string
          total_input_tokens: number
          total_output_tokens: number
        }
        Insert: {
          author?: string | null
          chunk_count?: number
          created_at?: string
          extraction_completed_at?: string | null
          extraction_started_at?: string | null
          id?: string
          notes?: string | null
          source_type?: string | null
          status?: string
          storage_path?: string | null
          title: string
          total_input_tokens?: number
          total_output_tokens?: number
        }
        Update: {
          author?: string | null
          chunk_count?: number
          created_at?: string
          extraction_completed_at?: string | null
          extraction_started_at?: string | null
          id?: string
          notes?: string | null
          source_type?: string | null
          status?: string
          storage_path?: string | null
          title?: string
          total_input_tokens?: number
          total_output_tokens?: number
        }
        Relationships: []
      }
      ingestion_unmapped_items: {
        Row: {
          created_at: string
          id: string
          item_kind: string | null
          raw_content: string
          reason: string
          source_id: string | null
          status: string
        }
        Insert: {
          created_at?: string
          id?: string
          item_kind?: string | null
          raw_content: string
          reason: string
          source_id?: string | null
          status?: string
        }
        Update: {
          created_at?: string
          id?: string
          item_kind?: string | null
          raw_content?: string
          reason?: string
          source_id?: string | null
          status?: string
        }
        Relationships: [
          {
            foreignKeyName: "ingestion_unmapped_items_source_id_fkey"
            columns: ["source_id"]
            isOneToOne: false
            referencedRelation: "ingestion_sources"
            referencedColumns: ["id"]
          },
        ]
      }
      injury_condition_regions: {
        Row: {
          condition_id: string
          region_id: string
        }
        Insert: {
          condition_id: string
          region_id: string
        }
        Update: {
          condition_id?: string
          region_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "injury_condition_regions_condition_id_fkey"
            columns: ["condition_id"]
            isOneToOne: false
            referencedRelation: "injury_conditions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "injury_condition_regions_region_id_fkey"
            columns: ["region_id"]
            isOneToOne: false
            referencedRelation: "body_regions"
            referencedColumns: ["id"]
          },
        ]
      }
      injury_conditions: {
        Row: {
          display_name: string
          id: string
        }
        Insert: {
          display_name: string
          id: string
        }
        Update: {
          display_name?: string
          id?: string
        }
        Relationships: []
      }
      mid_week_adjustments: {
        Row: {
          affected_sessions: string[]
          ai_action_summary: string
          ai_full_reasoning: string
          created_at: string
          generated_with_model: string
          id: string
          input_tokens: number
          output_tokens: number
          program_id: string
          reason_category: string
          reason_note: string
          triggered_at: string
          user_id: string
          week_start_date: string
        }
        Insert: {
          affected_sessions?: string[]
          ai_action_summary?: string
          ai_full_reasoning?: string
          created_at?: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          output_tokens?: number
          program_id: string
          reason_category: string
          reason_note: string
          triggered_at?: string
          user_id: string
          week_start_date: string
        }
        Update: {
          affected_sessions?: string[]
          ai_action_summary?: string
          ai_full_reasoning?: string
          created_at?: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          output_tokens?: number
          program_id?: string
          reason_category?: string
          reason_note?: string
          triggered_at?: string
          user_id?: string
          week_start_date?: string
        }
        Relationships: [
          {
            foreignKeyName: "mid_week_adjustments_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "programs"
            referencedColumns: ["id"]
          },
        ]
      }
      moderation_terms: {
        Row: {
          added_at: string
          severity: string
          term: string
        }
        Insert: {
          added_at?: string
          severity?: string
          term: string
        }
        Update: {
          added_at?: string
          severity?: string
          term?: string
        }
        Relationships: []
      }
      movement_patterns: {
        Row: {
          display_name: string
          id: string
        }
        Insert: {
          display_name: string
          id: string
        }
        Update: {
          display_name?: string
          id?: string
        }
        Relationships: []
      }
      muscle_groups: {
        Row: {
          id: string
        }
        Insert: {
          id: string
        }
        Update: {
          id?: string
        }
        Relationships: []
      }
      muscles: {
        Row: {
          display_name: string
          group_id: string | null
          id: string
        }
        Insert: {
          display_name: string
          group_id?: string | null
          id: string
        }
        Update: {
          display_name?: string
          group_id?: string | null
          id?: string
        }
        Relationships: [
          {
            foreignKeyName: "muscles_group_id_fkey"
            columns: ["group_id"]
            isOneToOne: false
            referencedRelation: "muscle_groups"
            referencedColumns: ["id"]
          },
        ]
      }
      profiles: {
        Row: {
          account_role: string
          age: number | null
          assessment_complete: boolean
          assessment_data: Json | null
          assisted_tests: Json | null
          avatar_url: string | null
          avoided_activities: string[] | null
          body_fat_percentage: number | null
          city: string | null
          coach_manages_schedule: boolean
          coach_schedule_rationale: string
          coaching_source: string
          confirmed_coach_schedule: Json | null
          country: string | null
          created_at: string
          deferred_actions: Json
          effort_tolerance: string | null
          energy_availability: string | null
          energy_availability_set_at: string | null
          equipment_assumed: boolean
          equipment_notes: string | null
          excluded_exercise_ids: string[]
          first_name: string | null
          full_optimization_brief: Json | null
          gender: string | null
          goals: string[]
          height_cm: number | null
          id: string
          include_mobility_addon: boolean
          injuries_data: Json | null
          injury_notes: string | null
          last_name: string | null
          main_goals: string[]
          never_trained: boolean | null
          nickname: string | null
          notification_previews: boolean
          onboarding_complete: boolean
          preferred_approaches: string[] | null
          preferred_days: string[]
          preferred_exercise_ids: string[]
          rep_maxes: Json | null
          review_mode: string
          selected_equipment: string[]
          selected_injuries: string[]
          session_length_minutes: number
          show_week_proposals: boolean
          skill_max_holds: Json | null
          tested_at: Json | null
          timezone: string | null
          training_age_adjustment_months: number
          training_break_months: number | null
          training_clock_started_on: string | null
          training_days_per_week: number
          training_emphases: string[] | null
          training_start_date: string | null
          unit_system: string
          updated_at: string
          uses_full_optimization: boolean
          weight_kg: number | null
        }
        Insert: {
          account_role?: string
          age?: number | null
          assessment_complete?: boolean
          assessment_data?: Json | null
          assisted_tests?: Json | null
          avatar_url?: string | null
          avoided_activities?: string[] | null
          body_fat_percentage?: number | null
          city?: string | null
          coach_manages_schedule?: boolean
          coach_schedule_rationale?: string
          coaching_source?: string
          confirmed_coach_schedule?: Json | null
          country?: string | null
          created_at?: string
          deferred_actions?: Json
          effort_tolerance?: string | null
          energy_availability?: string | null
          energy_availability_set_at?: string | null
          equipment_assumed?: boolean
          equipment_notes?: string | null
          excluded_exercise_ids?: string[]
          first_name?: string | null
          full_optimization_brief?: Json | null
          gender?: string | null
          goals?: string[]
          height_cm?: number | null
          id: string
          include_mobility_addon?: boolean
          injuries_data?: Json | null
          injury_notes?: string | null
          last_name?: string | null
          main_goals?: string[]
          never_trained?: boolean | null
          nickname?: string | null
          notification_previews?: boolean
          onboarding_complete?: boolean
          preferred_approaches?: string[] | null
          preferred_days?: string[]
          preferred_exercise_ids?: string[]
          rep_maxes?: Json | null
          review_mode?: string
          selected_equipment?: string[]
          selected_injuries?: string[]
          session_length_minutes?: number
          show_week_proposals?: boolean
          skill_max_holds?: Json | null
          tested_at?: Json | null
          timezone?: string | null
          training_age_adjustment_months?: number
          training_break_months?: number | null
          training_clock_started_on?: string | null
          training_days_per_week?: number
          training_emphases?: string[] | null
          training_start_date?: string | null
          unit_system?: string
          updated_at?: string
          uses_full_optimization?: boolean
          weight_kg?: number | null
        }
        Update: {
          account_role?: string
          age?: number | null
          assessment_complete?: boolean
          assessment_data?: Json | null
          assisted_tests?: Json | null
          avatar_url?: string | null
          avoided_activities?: string[] | null
          body_fat_percentage?: number | null
          city?: string | null
          coach_manages_schedule?: boolean
          coach_schedule_rationale?: string
          coaching_source?: string
          confirmed_coach_schedule?: Json | null
          country?: string | null
          created_at?: string
          deferred_actions?: Json
          effort_tolerance?: string | null
          energy_availability?: string | null
          energy_availability_set_at?: string | null
          equipment_assumed?: boolean
          equipment_notes?: string | null
          excluded_exercise_ids?: string[]
          first_name?: string | null
          full_optimization_brief?: Json | null
          gender?: string | null
          goals?: string[]
          height_cm?: number | null
          id?: string
          include_mobility_addon?: boolean
          injuries_data?: Json | null
          injury_notes?: string | null
          last_name?: string | null
          main_goals?: string[]
          never_trained?: boolean | null
          nickname?: string | null
          notification_previews?: boolean
          onboarding_complete?: boolean
          preferred_approaches?: string[] | null
          preferred_days?: string[]
          preferred_exercise_ids?: string[]
          rep_maxes?: Json | null
          review_mode?: string
          selected_equipment?: string[]
          selected_injuries?: string[]
          session_length_minutes?: number
          show_week_proposals?: boolean
          skill_max_holds?: Json | null
          tested_at?: Json | null
          timezone?: string | null
          training_age_adjustment_months?: number
          training_break_months?: number | null
          training_clock_started_on?: string | null
          training_days_per_week?: number
          training_emphases?: string[] | null
          training_start_date?: string | null
          unit_system?: string
          updated_at?: string
          uses_full_optimization?: boolean
          weight_kg?: number | null
        }
        Relationships: []
      }
      program_phases: {
        Row: {
          created_at: string
          description: string
          id: string
          is_complete: boolean
          is_deload: boolean
          phase_number: number
          program_id: string
          sort_order: number
          theme: string
          updated_at: string
          weeks_count: number
        }
        Insert: {
          created_at?: string
          description?: string
          id?: string
          is_complete?: boolean
          is_deload?: boolean
          phase_number: number
          program_id: string
          sort_order: number
          theme: string
          updated_at?: string
          weeks_count?: number
        }
        Update: {
          created_at?: string
          description?: string
          id?: string
          is_complete?: boolean
          is_deload?: boolean
          phase_number?: number
          program_id?: string
          sort_order?: number
          theme?: string
          updated_at?: string
          weeks_count?: number
        }
        Relationships: [
          {
            foreignKeyName: "program_phases_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "programs"
            referencedColumns: ["id"]
          },
        ]
      }
      program_session_exercises: {
        Row: {
          assist_kg: number | null
          block_name: string
          created_at: string
          exercise_id: string
          format_config: Json
          format_group_id: string | null
          format_group_order: number | null
          hold_seconds_max: number | null
          hold_seconds_min: number | null
          id: string
          intensity_note: string
          notes: string
          per_set_reps: number[]
          per_set_rest_seconds: number[]
          per_set_seconds: number[]
          per_set_types: string[]
          per_set_weight_kg: number[]
          position: number
          position_in_section: number | null
          program_session_id: string
          progression_config: Json | null
          progression_rule: string
          reps_max: number | null
          reps_min: number | null
          rest_seconds: number | null
          section_format: string
          section_id: string | null
          section_type: string
          selection_reason: string
          sets: number
          target_weight_kg: number | null
          tempo: string | null
          tempo_plan: Json | null
          updated_at: string
        }
        Insert: {
          assist_kg?: number | null
          block_name: string
          created_at?: string
          exercise_id: string
          format_config?: Json
          format_group_id?: string | null
          format_group_order?: number | null
          hold_seconds_max?: number | null
          hold_seconds_min?: number | null
          id?: string
          intensity_note?: string
          notes?: string
          per_set_reps?: number[]
          per_set_rest_seconds?: number[]
          per_set_seconds?: number[]
          per_set_types?: string[]
          per_set_weight_kg?: number[]
          position: number
          position_in_section?: number | null
          program_session_id: string
          progression_config?: Json | null
          progression_rule?: string
          reps_max?: number | null
          reps_min?: number | null
          rest_seconds?: number | null
          section_format?: string
          section_id?: string | null
          section_type?: string
          selection_reason?: string
          sets: number
          target_weight_kg?: number | null
          tempo?: string | null
          tempo_plan?: Json | null
          updated_at?: string
        }
        Update: {
          assist_kg?: number | null
          block_name?: string
          created_at?: string
          exercise_id?: string
          format_config?: Json
          format_group_id?: string | null
          format_group_order?: number | null
          hold_seconds_max?: number | null
          hold_seconds_min?: number | null
          id?: string
          intensity_note?: string
          notes?: string
          per_set_reps?: number[]
          per_set_rest_seconds?: number[]
          per_set_seconds?: number[]
          per_set_types?: string[]
          per_set_weight_kg?: number[]
          position?: number
          position_in_section?: number | null
          program_session_id?: string
          progression_config?: Json | null
          progression_rule?: string
          reps_max?: number | null
          reps_min?: number | null
          rest_seconds?: number | null
          section_format?: string
          section_id?: string | null
          section_type?: string
          selection_reason?: string
          sets?: number
          target_weight_kg?: number | null
          tempo?: string | null
          tempo_plan?: Json | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "program_session_exercises_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "program_session_exercises_program_session_id_fkey"
            columns: ["program_session_id"]
            isOneToOne: false
            referencedRelation: "program_sessions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "program_session_exercises_section_id_fkey"
            columns: ["section_id"]
            isOneToOne: false
            referencedRelation: "session_sections"
            referencedColumns: ["id"]
          },
        ]
      }
      program_sessions: {
        Row: {
          ai_reasoning: string
          created_at: string
          day_of_week: string
          description: string
          estimated_minutes: number | null
          focus_tags: string[]
          id: string
          name: string
          phase_id: string
          program_id: string
          session_number: number
          updated_at: string
          week_number: number
        }
        Insert: {
          ai_reasoning?: string
          created_at?: string
          day_of_week: string
          description?: string
          estimated_minutes?: number | null
          focus_tags?: string[]
          id?: string
          name: string
          phase_id: string
          program_id: string
          session_number: number
          updated_at?: string
          week_number: number
        }
        Update: {
          ai_reasoning?: string
          created_at?: string
          day_of_week?: string
          description?: string
          estimated_minutes?: number | null
          focus_tags?: string[]
          id?: string
          name?: string
          phase_id?: string
          program_id?: string
          session_number?: number
          updated_at?: string
          week_number?: number
        }
        Relationships: [
          {
            foreignKeyName: "program_sessions_phase_id_fkey"
            columns: ["phase_id"]
            isOneToOne: false
            referencedRelation: "program_phases"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "program_sessions_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "programs"
            referencedColumns: ["id"]
          },
        ]
      }
      programs: {
        Row: {
          ai_reasoning: string
          coach_notes: string
          current_phase: number
          current_week_in_phase: number
          description: string
          engine_config: Json | null
          generated_at: string | null
          generated_with_model: string
          generation_prompt_version: number
          id: string
          last_review_completed_at: string | null
          mid_week_adjustments_this_week: number
          name: string
          next_review_due_at: string | null
          primary_goal: string
          sessions_per_week: number
          status: string
          total_phases: number
          updated_at: string | null
          user_id: string
          week_started_at: string | null
          weeks: number
        }
        Insert: {
          ai_reasoning?: string
          coach_notes?: string
          current_phase?: number
          current_week_in_phase?: number
          description?: string
          engine_config?: Json | null
          generated_at?: string | null
          generated_with_model?: string
          generation_prompt_version?: number
          id?: string
          last_review_completed_at?: string | null
          mid_week_adjustments_this_week?: number
          name: string
          next_review_due_at?: string | null
          primary_goal?: string
          sessions_per_week?: number
          status?: string
          total_phases?: number
          updated_at?: string | null
          user_id: string
          week_started_at?: string | null
          weeks?: number
        }
        Update: {
          ai_reasoning?: string
          coach_notes?: string
          current_phase?: number
          current_week_in_phase?: number
          description?: string
          engine_config?: Json | null
          generated_at?: string | null
          generated_with_model?: string
          generation_prompt_version?: number
          id?: string
          last_review_completed_at?: string | null
          mid_week_adjustments_this_week?: number
          name?: string
          next_review_due_at?: string | null
          primary_goal?: string
          sessions_per_week?: number
          status?: string
          total_phases?: number
          updated_at?: string | null
          user_id?: string
          week_started_at?: string | null
          weeks?: number
        }
        Relationships: []
      }
      push_attempts: {
        Row: {
          apns_reason: string | null
          apns_status: number | null
          assignment_id: string | null
          caller_id: string | null
          created_at: string
          device_count: number | null
          fn: string
          id: string
          message_id: string | null
          recipient_id: string
          settled_at: string | null
          status: string
        }
        Insert: {
          apns_reason?: string | null
          apns_status?: number | null
          assignment_id?: string | null
          caller_id?: string | null
          created_at?: string
          device_count?: number | null
          fn: string
          id?: string
          message_id?: string | null
          recipient_id: string
          settled_at?: string | null
          status?: string
        }
        Update: {
          apns_reason?: string | null
          apns_status?: number | null
          assignment_id?: string | null
          caller_id?: string | null
          created_at?: string
          device_count?: number | null
          fn?: string
          id?: string
          message_id?: string | null
          recipient_id?: string
          settled_at?: string | null
          status?: string
        }
        Relationships: []
      }
      reaction_emoji: {
        Row: {
          emoji: string
          name: string
        }
        Insert: {
          emoji: string
          name: string
        }
        Update: {
          emoji?: string
          name?: string
        }
        Relationships: []
      }
      restricted_demo_videos: {
        Row: {
          coach_exercise_id: string | null
          created_at: string
          exercise_id: string | null
          id: string
          restriction: string
          video_url: string
        }
        Insert: {
          coach_exercise_id?: string | null
          created_at?: string
          exercise_id?: string | null
          id?: string
          restriction: string
          video_url: string
        }
        Update: {
          coach_exercise_id?: string | null
          created_at?: string
          exercise_id?: string | null
          id?: string
          restriction?: string
          video_url?: string
        }
        Relationships: [
          {
            foreignKeyName: "restricted_demo_videos_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "restricted_demo_videos_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      reviewer_review_items: {
        Row: {
          audio_path: string | null
          audio_seconds: number | null
          body: string | null
          created_at: string
          exercise_name: string | null
          id: string
          photo_path: string | null
          position: number
          review_id: string
          reviewer_id: string
          suggested: Json | null
          updated_at: string
          video_path: string | null
          video_seconds: number | null
          workout_session_exercise_id: string | null
        }
        Insert: {
          audio_path?: string | null
          audio_seconds?: number | null
          body?: string | null
          created_at?: string
          exercise_name?: string | null
          id?: string
          photo_path?: string | null
          position?: number
          review_id: string
          reviewer_id?: string
          suggested?: Json | null
          updated_at?: string
          video_path?: string | null
          video_seconds?: number | null
          workout_session_exercise_id?: string | null
        }
        Update: {
          audio_path?: string | null
          audio_seconds?: number | null
          body?: string | null
          created_at?: string
          exercise_name?: string | null
          id?: string
          photo_path?: string | null
          position?: number
          review_id?: string
          reviewer_id?: string
          suggested?: Json | null
          updated_at?: string
          video_path?: string | null
          video_seconds?: number | null
          workout_session_exercise_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "reviewer_review_items_review_id_fkey"
            columns: ["review_id"]
            isOneToOne: false
            referencedRelation: "reviewer_reviews"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "reviewer_review_items_workout_session_exercise_id_fkey"
            columns: ["workout_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "workout_session_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      reviewer_reviews: {
        Row: {
          audio_path: string | null
          audio_seconds: number | null
          body: string | null
          client_id: string
          created_at: string
          id: string
          photo_path: string | null
          reviewer_id: string
          scheduled_date: string
          seen_at: string | null
          sent_at: string | null
          session_id: string | null
          updated_at: string
          video_path: string | null
          video_seconds: number | null
        }
        Insert: {
          audio_path?: string | null
          audio_seconds?: number | null
          body?: string | null
          client_id: string
          created_at?: string
          id?: string
          photo_path?: string | null
          reviewer_id?: string
          scheduled_date: string
          seen_at?: string | null
          sent_at?: string | null
          session_id?: string | null
          updated_at?: string
          video_path?: string | null
          video_seconds?: number | null
        }
        Update: {
          audio_path?: string | null
          audio_seconds?: number | null
          body?: string | null
          client_id?: string
          created_at?: string
          id?: string
          photo_path?: string | null
          reviewer_id?: string
          scheduled_date?: string
          seen_at?: string | null
          sent_at?: string | null
          session_id?: string | null
          updated_at?: string
          video_path?: string | null
          video_seconds?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "reviewer_reviews_session_id_fkey"
            columns: ["session_id"]
            isOneToOne: false
            referencedRelation: "workout_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      reviewer_week_proposals: {
        Row: {
          client_id: string
          created_at: string
          id: string
          note: string | null
          reviewer_id: string
          seen_at: string | null
          sent_at: string | null
          updated_at: string
          week: Json
          week_start: string
        }
        Insert: {
          client_id: string
          created_at?: string
          id?: string
          note?: string | null
          reviewer_id?: string
          seen_at?: string | null
          sent_at?: string | null
          updated_at?: string
          week: Json
          week_start: string
        }
        Update: {
          client_id?: string
          created_at?: string
          id?: string
          note?: string | null
          reviewer_id?: string
          seen_at?: string | null
          sent_at?: string | null
          updated_at?: string
          week?: Json
          week_start?: string
        }
        Relationships: []
      }
      session_sections: {
        Row: {
          created_at: string
          format: string
          format_config: Json
          id: string
          name: string
          position: number
          program_session_id: string
          role: string
        }
        Insert: {
          created_at?: string
          format?: string
          format_config?: Json
          id?: string
          name: string
          position: number
          program_session_id: string
          role?: string
        }
        Update: {
          created_at?: string
          format?: string
          format_config?: Json
          id?: string
          name?: string
          position?: number
          program_session_id?: string
          role?: string
        }
        Relationships: [
          {
            foreignKeyName: "session_sections_program_session_id_fkey"
            columns: ["program_session_id"]
            isOneToOne: false
            referencedRelation: "program_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      set_logs: {
        Row: {
          assist_kg: number | null
          completed_at: string
          distance_m: number | null
          equipment_used_id: string | null
          hold_seconds: number | null
          id: string
          modifier_label_override: string
          modifier_value_numeric: number | null
          note: string
          reps_completed: number | null
          round_seconds: number | null
          rounds: number | null
          rpe: number | null
          set_number: number
          status: string
          user_id: string
          weight_kg: number | null
          workout_session_exercise_id: string
        }
        Insert: {
          assist_kg?: number | null
          completed_at?: string
          distance_m?: number | null
          equipment_used_id?: string | null
          hold_seconds?: number | null
          id?: string
          modifier_label_override?: string
          modifier_value_numeric?: number | null
          note?: string
          reps_completed?: number | null
          round_seconds?: number | null
          rounds?: number | null
          rpe?: number | null
          set_number: number
          status?: string
          user_id: string
          weight_kg?: number | null
          workout_session_exercise_id: string
        }
        Update: {
          assist_kg?: number | null
          completed_at?: string
          distance_m?: number | null
          equipment_used_id?: string | null
          hold_seconds?: number | null
          id?: string
          modifier_label_override?: string
          modifier_value_numeric?: number | null
          note?: string
          reps_completed?: number | null
          round_seconds?: number | null
          rounds?: number | null
          rpe?: number | null
          set_number?: number
          status?: string
          user_id?: string
          weight_kg?: number | null
          workout_session_exercise_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "set_logs_equipment_used_id_fkey"
            columns: ["equipment_used_id"]
            isOneToOne: false
            referencedRelation: "user_equipment"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "set_logs_workout_session_exercise_id_fkey"
            columns: ["workout_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "workout_session_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      starter_exercises: {
        Row: {
          catalog_exercise_id: string | null
          catalog_link_source: string | null
          category: string | null
          demo_video_source: string | null
          demo_video_url: string | null
          equipment: string[]
          is_hold: boolean
          key: string
          movement_pattern: string
          name: string
          primary_muscles: string[]
          sort_order: number
          tracking_fields: string[]
          typical_hold_seconds_max: number | null
          typical_hold_seconds_min: number | null
          typical_rep_range_max: number | null
          typical_rep_range_min: number | null
        }
        Insert: {
          catalog_exercise_id?: string | null
          catalog_link_source?: string | null
          category?: string | null
          demo_video_source?: string | null
          demo_video_url?: string | null
          equipment?: string[]
          is_hold?: boolean
          key: string
          movement_pattern: string
          name: string
          primary_muscles?: string[]
          sort_order?: number
          tracking_fields?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
        }
        Update: {
          catalog_exercise_id?: string | null
          catalog_link_source?: string | null
          category?: string | null
          demo_video_source?: string | null
          demo_video_url?: string | null
          equipment?: string[]
          is_hold?: boolean
          key?: string
          movement_pattern?: string
          name?: string
          primary_muscles?: string[]
          sort_order?: number
          tracking_fields?: string[]
          typical_hold_seconds_max?: number | null
          typical_hold_seconds_min?: number | null
          typical_rep_range_max?: number | null
          typical_rep_range_min?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "starter_exercises_catalog_exercise_id_fkey"
            columns: ["catalog_exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      tested_maxes: {
        Row: {
          client_id: string
          coach_exercise_id: string
          created_at: string
          entered_by: string | null
          id: number
          max_kg: number
          tested_on: string
        }
        Insert: {
          client_id?: string
          coach_exercise_id: string
          created_at?: string
          entered_by?: string | null
          id?: never
          max_kg: number
          tested_on: string
        }
        Update: {
          client_id?: string
          coach_exercise_id?: string
          created_at?: string
          entered_by?: string | null
          id?: never
          max_kg?: number
          tested_on?: string
        }
        Relationships: [
          {
            foreignKeyName: "tested_maxes_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
        ]
      }
      user_blocks: {
        Row: {
          blocked_id: string
          blocker_id: string
          created_at: string
        }
        Insert: {
          blocked_id: string
          blocker_id?: string
          created_at?: string
        }
        Update: {
          blocked_id?: string
          blocker_id?: string
          created_at?: string
        }
        Relationships: []
      }
      user_equipment: {
        Row: {
          category: string
          color: string
          created_at: string
          id: string
          is_active: boolean
          label: string
          notes: string
          resistance_estimate_kg: number | null
          sort_order: number
          updated_at: string
          user_id: string
          weight_kg: number | null
        }
        Insert: {
          category: string
          color?: string
          created_at?: string
          id?: string
          is_active?: boolean
          label: string
          notes?: string
          resistance_estimate_kg?: number | null
          sort_order?: number
          updated_at?: string
          user_id: string
          weight_kg?: number | null
        }
        Update: {
          category?: string
          color?: string
          created_at?: string
          id?: string
          is_active?: boolean
          label?: string
          notes?: string
          resistance_estimate_kg?: number | null
          sort_order?: number
          updated_at?: string
          user_id?: string
          weight_kg?: number | null
        }
        Relationships: []
      }
      user_landmark_overrides: {
        Row: {
          created_at: string
          evidence: Json | null
          id: string
          kind: string
          muscle_group: string
          user_id: string
          value: number
          version: number
        }
        Insert: {
          created_at?: string
          evidence?: Json | null
          id?: string
          kind: string
          muscle_group: string
          user_id: string
          value: number
          version?: number
        }
        Update: {
          created_at?: string
          evidence?: Json | null
          id?: string
          kind?: string
          muscle_group?: string
          user_id?: string
          value?: number
          version?: number
        }
        Relationships: []
      }
      user_reports: {
        Row: {
          created_at: string
          id: string
          note: string | null
          reason: string
          reporter_id: string
          subject_id: string
        }
        Insert: {
          created_at?: string
          id?: string
          note?: string | null
          reason: string
          reporter_id?: string
          subject_id: string
        }
        Update: {
          created_at?: string
          id?: string
          note?: string | null
          reason?: string
          reporter_id?: string
          subject_id?: string
        }
        Relationships: []
      }
      user_sanctions: {
        Row: {
          expires_at: string | null
          id: string
          issued_at: string
          issued_by: string | null
          kind: string
          reason: string
          severity: string
          user_id: string
        }
        Insert: {
          expires_at?: string | null
          id?: string
          issued_at?: string
          issued_by?: string | null
          kind: string
          reason: string
          severity?: string
          user_id: string
        }
        Update: {
          expires_at?: string | null
          id?: string
          issued_at?: string
          issued_by?: string | null
          kind?: string
          reason?: string
          severity?: string
          user_id?: string
        }
        Relationships: []
      }
      weekly_reviews: {
        Row: {
          ai_change_preview: string
          ai_full_reasoning: string
          ai_summary: string
          avg_rpe: number | null
          completed_at: string | null
          created_at: string
          free_form_note: string
          generated_with_model: string
          id: string
          input_tokens: number
          life_changes_note: string
          new_injuries_flagged: boolean
          output_tokens: number
          overall_feeling: number
          pain_reports: Json | null
          phase_id: string
          program_id: string
          prs_count: number
          sessions_completed: number
          sessions_partial: number
          sessions_prescribed: number
          sessions_skipped: number
          stalled_exercises_count: number
          targeted_qas: Json
          total_volume_kg: number
          total_volume_reps: number
          tweak_request_note: string
          user_action: string
          user_id: string
          week_end_date: string
          week_number_in_phase: number
          week_start_date: string
        }
        Insert: {
          ai_change_preview?: string
          ai_full_reasoning?: string
          ai_summary?: string
          avg_rpe?: number | null
          completed_at?: string | null
          created_at?: string
          free_form_note?: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          life_changes_note?: string
          new_injuries_flagged?: boolean
          output_tokens?: number
          overall_feeling: number
          pain_reports?: Json | null
          phase_id: string
          program_id: string
          prs_count?: number
          sessions_completed?: number
          sessions_partial?: number
          sessions_prescribed?: number
          sessions_skipped?: number
          stalled_exercises_count?: number
          targeted_qas?: Json
          total_volume_kg?: number
          total_volume_reps?: number
          tweak_request_note?: string
          user_action?: string
          user_id: string
          week_end_date: string
          week_number_in_phase: number
          week_start_date: string
        }
        Update: {
          ai_change_preview?: string
          ai_full_reasoning?: string
          ai_summary?: string
          avg_rpe?: number | null
          completed_at?: string | null
          created_at?: string
          free_form_note?: string
          generated_with_model?: string
          id?: string
          input_tokens?: number
          life_changes_note?: string
          new_injuries_flagged?: boolean
          output_tokens?: number
          overall_feeling?: number
          pain_reports?: Json | null
          phase_id?: string
          program_id?: string
          prs_count?: number
          sessions_completed?: number
          sessions_partial?: number
          sessions_prescribed?: number
          sessions_skipped?: number
          stalled_exercises_count?: number
          targeted_qas?: Json
          total_volume_kg?: number
          total_volume_reps?: number
          tweak_request_note?: string
          user_action?: string
          user_id?: string
          week_end_date?: string
          week_number_in_phase?: number
          week_start_date?: string
        }
        Relationships: [
          {
            foreignKeyName: "weekly_reviews_phase_id_fkey"
            columns: ["phase_id"]
            isOneToOne: false
            referencedRelation: "program_phases"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "weekly_reviews_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "programs"
            referencedColumns: ["id"]
          },
        ]
      }
      workout_session_exercises: {
        Row: {
          actual_sets: number
          coach_exercise_id: string | null
          completion_status: string
          created_at: string
          exercise_completed_at: string | null
          exercise_id: string | null
          exercise_started_at: string | null
          hold_seconds_per_set: number[]
          id: string
          notes: string
          per_exercise_note: string
          position: number
          program_session_exercise_id: string | null
          reps_per_set: number[]
          rpe_per_set: number[]
          section_role: string | null
          status: string
          swapped_from_exercise_id: string | null
          updated_at: string
          was_swapped: boolean
          weight_per_set_kg: number[]
          workout_session_id: string
        }
        Insert: {
          actual_sets?: number
          coach_exercise_id?: string | null
          completion_status?: string
          created_at?: string
          exercise_completed_at?: string | null
          exercise_id?: string | null
          exercise_started_at?: string | null
          hold_seconds_per_set?: number[]
          id?: string
          notes?: string
          per_exercise_note?: string
          position: number
          program_session_exercise_id?: string | null
          reps_per_set?: number[]
          rpe_per_set?: number[]
          section_role?: string | null
          status?: string
          swapped_from_exercise_id?: string | null
          updated_at?: string
          was_swapped?: boolean
          weight_per_set_kg?: number[]
          workout_session_id: string
        }
        Update: {
          actual_sets?: number
          coach_exercise_id?: string | null
          completion_status?: string
          created_at?: string
          exercise_completed_at?: string | null
          exercise_id?: string | null
          exercise_started_at?: string | null
          hold_seconds_per_set?: number[]
          id?: string
          notes?: string
          per_exercise_note?: string
          position?: number
          program_session_exercise_id?: string | null
          reps_per_set?: number[]
          rpe_per_set?: number[]
          section_role?: string | null
          status?: string
          swapped_from_exercise_id?: string | null
          updated_at?: string
          was_swapped?: boolean
          weight_per_set_kg?: number[]
          workout_session_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "workout_session_exercises_coach_exercise_id_fkey"
            columns: ["coach_exercise_id"]
            isOneToOne: false
            referencedRelation: "coach_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_session_exercises_exercise_id_fkey"
            columns: ["exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_session_exercises_program_session_exercise_id_fkey"
            columns: ["program_session_exercise_id"]
            isOneToOne: false
            referencedRelation: "program_session_exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_session_exercises_swapped_from_exercise_id_fkey"
            columns: ["swapped_from_exercise_id"]
            isOneToOne: false
            referencedRelation: "exercises"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_session_exercises_workout_session_id_fkey"
            columns: ["workout_session_id"]
            isOneToOne: false
            referencedRelation: "workout_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      workout_sessions: {
        Row: {
          ai_adjusted: boolean
          ai_adjustment_reason: string
          coach_assignment_id: string | null
          completed_at: string | null
          created_at: string | null
          duration_actual_minutes: number | null
          id: string
          kind: string
          perceived_difficulty: number | null
          performance_notes: string
          program_id: string | null
          program_session_id: string | null
          readiness_score: number | null
          scheduled_date: string | null
          session_number: number
          status: string
          updated_at: string | null
          user_id: string
          week_number: number
        }
        Insert: {
          ai_adjusted?: boolean
          ai_adjustment_reason?: string
          coach_assignment_id?: string | null
          completed_at?: string | null
          created_at?: string | null
          duration_actual_minutes?: number | null
          id?: string
          kind?: string
          perceived_difficulty?: number | null
          performance_notes?: string
          program_id?: string | null
          program_session_id?: string | null
          readiness_score?: number | null
          scheduled_date?: string | null
          session_number?: number
          status?: string
          updated_at?: string | null
          user_id: string
          week_number?: number
        }
        Update: {
          ai_adjusted?: boolean
          ai_adjustment_reason?: string
          coach_assignment_id?: string | null
          completed_at?: string | null
          created_at?: string | null
          duration_actual_minutes?: number | null
          id?: string
          kind?: string
          perceived_difficulty?: number | null
          performance_notes?: string
          program_id?: string | null
          program_session_id?: string | null
          readiness_score?: number | null
          scheduled_date?: string | null
          session_number?: number
          status?: string
          updated_at?: string | null
          user_id?: string
          week_number?: number
        }
        Relationships: [
          {
            foreignKeyName: "workout_sessions_coach_assignment_id_fkey"
            columns: ["coach_assignment_id"]
            isOneToOne: false
            referencedRelation: "coach_assignments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_sessions_program_id_fkey"
            columns: ["program_id"]
            isOneToOne: false
            referencedRelation: "programs"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workout_sessions_program_session_id_fkey"
            columns: ["program_session_id"]
            isOneToOne: false
            referencedRelation: "program_sessions"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      accept_coach_invitation: {
        Args: { p_invitation_id: string }
        Returns: undefined
      }
      assert_clone_covers: {
        Args: { p_cols: string[]; p_table: string }
        Returns: undefined
      }
      assign_coach_workout: {
        Args: {
          p_client_id: string
          p_note: string
          p_scheduled_date: string
          p_workout_id: string
        }
        Returns: string
      }
      assigned_workout_tree: { Args: { p_workout_id: string }; Returns: Json }
      blocked_between: { Args: { a: string; b: string }; Returns: boolean }
      call_minutes_allowance: { Args: never; Returns: number }
      call_minutes_used: {
        Args: { p_at: string; p_coach: string }
        Returns: number
      }
      call_room_claim: { Args: { p_call: string }; Returns: Json }
      claim_coach_invitation: { Args: { p_token: string }; Returns: string }
      clone_coach_workout: {
        Args: { p_client_id: string; p_workout_id: string }
        Returns: string
      }
      coach_directory_counts: {
        Args: never
        Returns: {
          coach_id: string
          followers: number
          posts: number
        }[]
      }
      coach_post_like_counts: {
        Args: never
        Returns: {
          likes: number
          post_id: string
        }[]
      }
      comment_rate_exceeded: { Args: { who: string }; Returns: boolean }
      create_client_workout: {
        Args: {
          p_client_id: string
          p_description: string
          p_name: string
          p_scheduled_date: string
        }
        Returns: {
          new_assignment_id: string
          new_workout_id: string
        }[]
      }
      decline_coach_invitation: {
        Args: { p_invitation_id: string }
        Returns: undefined
      }
      increment_coach_knowledge_reference: {
        Args: { entry_id: string }
        Returns: undefined
      }
      is_admin_identity: {
        Args: { p_email: string; p_user_id: string }
        Returns: boolean
      }
      is_app_admin: { Args: never; Returns: boolean }
      is_beta_admin: { Args: never; Returns: boolean }
      is_catalogue_admin: { Args: never; Returns: boolean }
      is_silenced: { Args: { who: string }; Returns: boolean }
      moderation_verdict: { Args: { body: string }; Returns: string }
      normalise_exercise_name: { Args: { p: string }; Returns: string }
      normalize_injury_map: { Args: { raw: Json }; Returns: Json }
      owns_post: { Args: { post: string; who: string }; Returns: boolean }
      peek_coach_invitation: {
        Args: { p_token: string }
        Returns: {
          coach_name: string
          expires_at: string
          invited_first_name: string
          invited_last_name: string
        }[]
      }
      post_rate_exceeded: { Args: { who: string }; Returns: boolean }
      register_push_token: {
        Args: {
          p_app_build?: string
          p_environment: string
          p_token: string
          p_topic?: string
        }
        Returns: string
      }
      reviewer_accept: { Args: { p_link: string }; Returns: undefined }
      reviewer_end: { Args: { p_link: string }; Returns: undefined }
      reviewer_has_active_link: { Args: never; Returns: boolean }
      reviewer_invite: { Args: { p_email: string }; Returns: string }
      reviewer_is_active: { Args: { p_client: string }; Returns: boolean }
      reviewer_links: {
        Args: never
        Returns: {
          accepted_at: string
          client_id: string
          ended_at: string
          id: string
          invited_at: string
          invited_email: string
          other_name: string
          reviewer_id: string
          role: string
          status: string
        }[]
      }
      reviewer_proposal_seen: {
        Args: { p_proposal: string }
        Returns: undefined
      }
      reviewer_reads_clip: { Args: { p_name: string }; Returns: boolean }
      reviewer_review_seen: { Args: { p_review: string }; Returns: undefined }
      reviewer_sessions: {
        Args: { p_client: string; p_from: string; p_to: string }
        Returns: Json
      }
      reviewer_week: {
        Args: { p_client: string; p_from: string; p_to: string }
        Returns: Json
      }
      reviewer_week_node_ok: {
        Args: { p_level: string; p_node: Json }
        Returns: boolean
      }
      reviewer_week_shape_ok: {
        Args: { p_week: Json; p_week_start: string }
        Returns: boolean
      }
      reviewer_week_vocabulary: { Args: never; Returns: Json }
      save_week_as_program: {
        Args: { p_days: Json; p_name: string }
        Returns: string
      }
      seed_coach_library: { Args: never; Returns: number }
      stamp_founder: {
        Args: { p_coach: string; p_note?: string }
        Returns: number
      }
      tempo_total_seconds: { Args: { tempo: string }; Returns: number }
      unsend_message: { Args: { p_message_id: string }; Returns: boolean }
      upsert_exercise_user_state_from_set_log: {
        Args: { set_log_id: string }
        Returns: undefined
      }
      write_week_trees: { Args: { p_trees: Json }; Returns: Json }
    }
    Enums: {
      exercise_category:
        | "strength"
        | "hypertrophy"
        | "skill"
        | "cardio"
        | "mobility"
        | "power"
        | "endurance"
        | "rehab"
      exercise_type:
        | "calisthenics"
        | "weighted"
        | "hybrid"
        | "cardio"
        | "mobility"
      loading_type:
        | "bodyweight"
        | "external_load"
        | "band"
        | "variable"
        | "none"
      movement_pattern:
        | "push"
        | "pull"
        | "hinge"
        | "squat"
        | "lunge"
        | "carry"
        | "core"
        | "skill"
        | "cardio"
        | "mobility"
        | "isometric"
      movement_plane: "sagittal" | "frontal" | "transverse" | "multi"
      review_status:
        | "draft"
        | "published"
        | "needs_review"
        | "deprecated"
        | "ai_approved"
        | "ai_rejected"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends (DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never) = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends (PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never) = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  public: {
    Enums: {
      exercise_category: [
        "strength",
        "hypertrophy",
        "skill",
        "cardio",
        "mobility",
        "power",
        "endurance",
        "rehab",
      ],
      exercise_type: [
        "calisthenics",
        "weighted",
        "hybrid",
        "cardio",
        "mobility",
      ],
      loading_type: ["bodyweight", "external_load", "band", "variable", "none"],
      movement_pattern: [
        "push",
        "pull",
        "hinge",
        "squat",
        "lunge",
        "carry",
        "core",
        "skill",
        "cardio",
        "mobility",
        "isometric",
      ],
      movement_plane: ["sagittal", "frontal", "transverse", "multi"],
      review_status: [
        "draft",
        "published",
        "needs_review",
        "deprecated",
        "ai_approved",
        "ai_rejected",
      ],
    },
  },
} as const
